import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { of, throwError } from 'rxjs';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppEnablementStatusesAppEnablementStatus = /*#__PURE__*/function (AppEnablementStatusesAppEnablementStatus) {
  AppEnablementStatusesAppEnablementStatus[AppEnablementStatusesAppEnablementStatus["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  AppEnablementStatusesAppEnablementStatus[AppEnablementStatusesAppEnablementStatus["ENABLED"] = 1] = "ENABLED";
  AppEnablementStatusesAppEnablementStatus[AppEnablementStatusesAppEnablementStatus["DISABLED"] = 2] = "DISABLED";
  return AppEnablementStatusesAppEnablementStatus;
}(AppEnablementStatusesAppEnablementStatus || {});
var CurrenciesCurrency = /*#__PURE__*/function (CurrenciesCurrency) {
  CurrenciesCurrency[CurrenciesCurrency["USD"] = 0] = "USD";
  CurrenciesCurrency[CurrenciesCurrency["AUD"] = 1] = "AUD";
  CurrenciesCurrency[CurrenciesCurrency["BRL"] = 2] = "BRL";
  CurrenciesCurrency[CurrenciesCurrency["CAD"] = 3] = "CAD";
  CurrenciesCurrency[CurrenciesCurrency["CHF"] = 4] = "CHF";
  CurrenciesCurrency[CurrenciesCurrency["CNY"] = 5] = "CNY";
  CurrenciesCurrency[CurrenciesCurrency["CZK"] = 6] = "CZK";
  CurrenciesCurrency[CurrenciesCurrency["EUR"] = 7] = "EUR";
  CurrenciesCurrency[CurrenciesCurrency["GBP"] = 8] = "GBP";
  CurrenciesCurrency[CurrenciesCurrency["HKD"] = 9] = "HKD";
  CurrenciesCurrency[CurrenciesCurrency["INR"] = 10] = "INR";
  CurrenciesCurrency[CurrenciesCurrency["JPY"] = 11] = "JPY";
  CurrenciesCurrency[CurrenciesCurrency["KHR"] = 12] = "KHR";
  CurrenciesCurrency[CurrenciesCurrency["KRW"] = 13] = "KRW";
  CurrenciesCurrency[CurrenciesCurrency["MXN"] = 14] = "MXN";
  CurrenciesCurrency[CurrenciesCurrency["NOK"] = 15] = "NOK";
  CurrenciesCurrency[CurrenciesCurrency["NZD"] = 16] = "NZD";
  CurrenciesCurrency[CurrenciesCurrency["RUB"] = 17] = "RUB";
  CurrenciesCurrency[CurrenciesCurrency["SEK"] = 18] = "SEK";
  CurrenciesCurrency[CurrenciesCurrency["SGD"] = 19] = "SGD";
  CurrenciesCurrency[CurrenciesCurrency["TRY"] = 20] = "TRY";
  CurrenciesCurrency[CurrenciesCurrency["ZAR"] = 21] = "ZAR";
  CurrenciesCurrency[CurrenciesCurrency["DZD"] = 22] = "DZD";
  CurrenciesCurrency[CurrenciesCurrency["AWG"] = 23] = "AWG";
  CurrenciesCurrency[CurrenciesCurrency["FJD"] = 24] = "FJD";
  CurrenciesCurrency[CurrenciesCurrency["KYD"] = 25] = "KYD";
  return CurrenciesCurrency;
}(CurrenciesCurrency || {});
var FrequenciesFrequency = /*#__PURE__*/function (FrequenciesFrequency) {
  FrequenciesFrequency[FrequenciesFrequency["MONTHLY"] = 0] = "MONTHLY";
  FrequenciesFrequency[FrequenciesFrequency["DAILY"] = 1] = "DAILY";
  FrequenciesFrequency[FrequenciesFrequency["ONCE"] = 2] = "ONCE";
  FrequenciesFrequency[FrequenciesFrequency["YEARLY"] = 3] = "YEARLY";
  FrequenciesFrequency[FrequenciesFrequency["WEEKLY"] = 4] = "WEEKLY";
  FrequenciesFrequency[FrequenciesFrequency["OTHER"] = 5] = "OTHER";
  return FrequenciesFrequency;
}(FrequenciesFrequency || {});
var PricingDisplayOption = /*#__PURE__*/function (PricingDisplayOption) {
  PricingDisplayOption[PricingDisplayOption["PRICING_DISPLAY_OPTION_NOT_SPECIFIED"] = 0] = "PRICING_DISPLAY_OPTION_NOT_SPECIFIED";
  PricingDisplayOption[PricingDisplayOption["PRICING_DISPLAY_OPTION_CONTACT_SALES"] = 1] = "PRICING_DISPLAY_OPTION_CONTACT_SALES";
  PricingDisplayOption[PricingDisplayOption["PRICING_DISPLAY_OPTION_STARTING_AT"] = 2] = "PRICING_DISPLAY_OPTION_STARTING_AT";
  return PricingDisplayOption;
}(PricingDisplayOption || {});
var StatusesStatus = /*#__PURE__*/function (StatusesStatus) {
  StatusesStatus[StatusesStatus["DRAFT"] = 0] = "DRAFT";
  StatusesStatus[StatusesStatus["PUBLISHED"] = 1] = "PUBLISHED";
  StatusesStatus[StatusesStatus["ARCHIVED"] = 2] = "ARCHIVED";
  return StatusesStatus;
}(StatusesStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LmiCategories = /*#__PURE__*/function (LmiCategories) {
  LmiCategories[LmiCategories["NOT_SET"] = 0] = "NOT_SET";
  LmiCategories[LmiCategories["WEBSITE"] = 1] = "WEBSITE";
  LmiCategories[LmiCategories["CONTENT_AND_EXPERIENCE"] = 2] = "CONTENT_AND_EXPERIENCE";
  LmiCategories[LmiCategories["LISTINGS"] = 3] = "LISTINGS";
  LmiCategories[LmiCategories["REPUTATION"] = 4] = "REPUTATION";
  LmiCategories[LmiCategories["SEO"] = 5] = "SEO";
  LmiCategories[LmiCategories["SOCIAL"] = 6] = "SOCIAL";
  LmiCategories[LmiCategories["ADVERTISING"] = 7] = "ADVERTISING";
  return LmiCategories;
}(LmiCategories || {});
var State = /*#__PURE__*/function (State) {
  State[State["STATE_INVALID"] = 0] = "STATE_INVALID";
  State[State["STATE_DRAFT"] = 1] = "STATE_DRAFT";
  State[State["STATE_PUBLISHED"] = 2] = "STATE_PUBLISHED";
  return State;
}(State || {});
var ServiceModelType = /*#__PURE__*/function (ServiceModelType) {
  ServiceModelType[ServiceModelType["DIY"] = 0] = "DIY";
  ServiceModelType[ServiceModelType["DIWM"] = 1] = "DIWM";
  ServiceModelType[ServiceModelType["DIFM"] = 2] = "DIFM";
  return ServiceModelType;
}(ServiceModelType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppType$1 = /*#__PURE__*/function (AppType) {
  AppType[AppType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  AppType[AppType["APP"] = 1] = "APP";
  AppType[AppType["ADDON"] = 2] = "ADDON";
  AppType[AppType["CUSTOM_PRODUCT"] = 3] = "CUSTOM_PRODUCT";
  return AppType;
}(AppType$1 || {});
var DiscoverProductSortOrderType = /*#__PURE__*/function (DiscoverProductSortOrderType) {
  DiscoverProductSortOrderType[DiscoverProductSortOrderType["SORT_ORDER_NOT_SPECIFIED"] = 0] = "SORT_ORDER_NOT_SPECIFIED";
  DiscoverProductSortOrderType[DiscoverProductSortOrderType["SORT_ORDER_RELEASED"] = 1] = "SORT_ORDER_RELEASED";
  DiscoverProductSortOrderType[DiscoverProductSortOrderType["SORT_ORDER_TRENDING"] = 2] = "SORT_ORDER_TRENDING";
  DiscoverProductSortOrderType[DiscoverProductSortOrderType["SORT_ORDER_TOP_SELLING"] = 3] = "SORT_ORDER_TOP_SELLING";
  return DiscoverProductSortOrderType;
}(DiscoverProductSortOrderType || {});
var ProductPricingType = /*#__PURE__*/function (ProductPricingType) {
  ProductPricingType[ProductPricingType["INVALID"] = 0] = "INVALID";
  ProductPricingType[ProductPricingType["STANDARD"] = 1] = "STANDARD";
  ProductPricingType[ProductPricingType["STAIRSTEP"] = 2] = "STAIRSTEP";
  ProductPricingType[ProductPricingType["TIERED"] = 3] = "TIERED";
  return ProductPricingType;
}(ProductPricingType || {});
var StateFilterOptions = /*#__PURE__*/function (StateFilterOptions) {
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_PUBLISHED"] = 0] = "STATE_FILTER_OPTIONS_PUBLISHED";
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_DRAFT"] = 1] = "STATE_FILTER_OPTIONS_DRAFT";
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_ALL"] = 2] = "STATE_FILTER_OPTIONS_ALL";
  return StateFilterOptions;
}(StateFilterOptions || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ShoppingCartItemType = /*#__PURE__*/function (ShoppingCartItemType) {
  ShoppingCartItemType[ShoppingCartItemType["SHOPPING_CART_ITEM_TYPE_INVALID"] = 0] = "SHOPPING_CART_ITEM_TYPE_INVALID";
  ShoppingCartItemType[ShoppingCartItemType["SHOPPING_CART_ITEM_TYPE_PACKAGE"] = 1] = "SHOPPING_CART_ITEM_TYPE_PACKAGE";
  ShoppingCartItemType[ShoppingCartItemType["SHOPPING_CART_ITEM_TYPE_PRODUCT"] = 2] = "SHOPPING_CART_ITEM_TYPE_PRODUCT";
  return ShoppingCartItemType;
}(ShoppingCartItemType || {});
// *********************************

function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonKey {
  static fromProto(proto) {
    let m = new AddonKey();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class AppEnablementStatuses {
  static fromProto(proto) {
    let m = new AppEnablementStatuses();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ContactFormAction {
  static fromProto(proto) {
    let m = new ContactFormAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Currencies {
  static fromProto(proto) {
    let m = new Currencies();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class DefaultAction {
  static fromProto(proto) {
    let m = new DefaultAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ExternalUrlAction {
  static fromProto(proto) {
    let m = new ExternalUrlAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class Frequencies {
  static fromProto(proto) {
    let m = new Frequencies();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class LineItem {
  static fromProto(proto) {
    let m = new LineItem();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class LineItems {
  static fromProto(proto) {
    let m = new LineItems();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class MarketAction {
  static fromProto(proto) {
    let m = new MarketAction();
    m = Object.assign(m, proto);
    if (proto.default) {
      m.default = DefaultAction.fromProto(proto.default);
    }
    if (proto.externalUrl) {
      m.externalUrl = ExternalUrlAction.fromProto(proto.externalUrl);
    }
    if (proto.contactForm) {
      m.contactForm = ContactFormAction.fromProto(proto.contactForm);
    }
    if (proto.orderForm) {
      m.orderForm = OrderFormAction.fromProto(proto.orderForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.default !== 'undefined' && this.default !== null) {
      toReturn['default'] = 'toApiJson' in this.default ? this.default.toApiJson() : this.default;
    }
    if (typeof this.externalUrl !== 'undefined' && this.externalUrl !== null) {
      toReturn['externalUrl'] = 'toApiJson' in this.externalUrl ? this.externalUrl.toApiJson() : this.externalUrl;
    }
    if (typeof this.contactForm !== 'undefined' && this.contactForm !== null) {
      toReturn['contactForm'] = 'toApiJson' in this.contactForm ? this.contactForm.toApiJson() : this.contactForm;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    return toReturn;
  }
}
class OrderFormAction {
  static fromProto(proto) {
    let m = new OrderFormAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Package {
  static fromProto(proto) {
    let m = new Package();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    if (proto.status) {
      m.status = enumStringToValue$b(StatusesStatus, proto.status);
    }
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.normalizedAnnualPrice) {
      m.normalizedAnnualPrice = parseInt(proto.normalizedAnnualPrice, 10);
    }
    if (proto.addonKeys) {
      m.addonKeys = proto.addonKeys.map(AddonKey.fromProto);
    }
    if (proto.lineItems) {
      m.lineItems = LineItems.fromProto(proto.lineItems);
    }
    if (proto.marketAction) {
      m.marketAction = MarketAction.fromProto(proto.marketAction);
    }
    if (proto.pricingDisplayOption) {
      m.pricingDisplayOption = enumStringToValue$b(PricingDisplayOption, proto.pricingDisplayOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.updatedBy !== 'undefined') {
      toReturn['updatedBy'] = this.updatedBy;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.headerImageUrl !== 'undefined') {
      toReturn['headerImageUrl'] = this.headerImageUrl;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.products !== 'undefined') {
      toReturn['products'] = this.products;
    }
    if (typeof this.hideProductDetails !== 'undefined') {
      toReturn['hideProductDetails'] = this.hideProductDetails;
    }
    if (typeof this.hideProductIconsAndNames !== 'undefined') {
      toReturn['hideProductIconsAndNames'] = this.hideProductIconsAndNames;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.normalizedAnnualPrice !== 'undefined') {
      toReturn['normalizedAnnualPrice'] = this.normalizedAnnualPrice;
    }
    if (typeof this.addonKeys !== 'undefined' && this.addonKeys !== null) {
      toReturn['addonKeys'] = 'toApiJson' in this.addonKeys ? this.addonKeys.toApiJson() : this.addonKeys;
    }
    if (typeof this.productOrder !== 'undefined') {
      toReturn['productOrder'] = this.productOrder;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.marketAction !== 'undefined' && this.marketAction !== null) {
      toReturn['marketAction'] = 'toApiJson' in this.marketAction ? this.marketAction.toApiJson() : this.marketAction;
    }
    if (typeof this.usesBillingPricing !== 'undefined') {
      toReturn['usesBillingPricing'] = this.usesBillingPricing;
    }
    if (typeof this.pricingDisplayOption !== 'undefined') {
      toReturn['pricingDisplayOption'] = this.pricingDisplayOption;
    }
    return toReturn;
  }
}
class Price {
  static fromProto(proto) {
    let m = new Price();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$b(FrequenciesFrequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.isStartingPrice !== 'undefined') {
      toReturn['isStartingPrice'] = this.isStartingPrice;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class Pricing {
  static fromProto(proto) {
    let m = new Pricing();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$b(CurrenciesCurrency, proto.currency);
    }
    if (proto.prices) {
      m.prices = proto.prices.map(Price.fromProto);
    }
    if (proto.price) {
      m.price = Price.fromProto(proto.price);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    if (typeof this.price !== 'undefined' && this.price !== null) {
      toReturn['price'] = 'toApiJson' in this.price ? this.price.toApiJson() : this.price;
    }
    return toReturn;
  }
}
class Statuses {
  static fromProto(proto) {
    let m = new Statuses();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
let PermissionLists$1 = class PermissionLists {
  static fromProto(proto) {
    let m = new PermissionLists();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined') {
      toReturn['blacklist'] = this.blacklist;
    }
    return toReturn;
  }
};
class Restrictions {
  static fromProto(proto) {
    let m = new Restrictions();
    m = Object.assign(m, proto);
    if (proto.country) {
      m.country = PermissionLists$1.fromProto(proto.country);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FrequentlyAskedQuestions {
  static fromProto(proto) {
    let m = new FrequentlyAskedQuestions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined') {
      toReturn['question'] = this.question;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    return toReturn;
  }
}
class Lmi {
  static fromProto(proto) {
    let m = new Lmi();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Product {
  static fromProto(proto) {
    let m = new Product();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$9(CurrenciesCurrency, proto.currency);
    }
    if (proto.serviceModel) {
      m.serviceModel = proto.serviceModel.map(v => enumStringToValue$9(ServiceModelType, v));
    }
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$9(LmiCategories, v));
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.faqs) {
      m.faqs = proto.faqs.map(FrequentlyAskedQuestions.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.state) {
      m.state = enumStringToValue$9(State, proto.state);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.suspended) {
      m.suspended = new Date(proto.suspended);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.headerImageUrl !== 'undefined') {
      toReturn['headerImageUrl'] = this.headerImageUrl;
    }
    if (typeof this.screenshotUrls !== 'undefined') {
      toReturn['screenshotUrls'] = this.screenshotUrls;
    }
    if (typeof this.pdfUploadUrls !== 'undefined') {
      toReturn['pdfUploadUrls'] = this.pdfUploadUrls;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.wholesalePrice !== 'undefined') {
      toReturn['wholesalePrice'] = this.wholesalePrice;
    }
    if (typeof this.recommendedSellPrice !== 'undefined') {
      toReturn['recommendedSellPrice'] = this.recommendedSellPrice;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.usesCustomizationForm !== 'undefined') {
      toReturn['usesCustomizationForm'] = this.usesCustomizationForm;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.websiteUrl !== 'undefined') {
      toReturn['websiteUrl'] = this.websiteUrl;
    }
    if (typeof this.updatedBy !== 'undefined') {
      toReturn['updatedBy'] = this.updatedBy;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.faqs !== 'undefined' && this.faqs !== null) {
      toReturn['faqs'] = 'toApiJson' in this.faqs ? this.faqs.toApiJson() : this.faqs;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.isArchived !== 'undefined') {
      toReturn['isArchived'] = this.isArchived;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.usesActivationSpecificEntryUrl !== 'undefined') {
      toReturn['usesActivationSpecificEntryUrl'] = this.usesActivationSpecificEntryUrl;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.suspended !== 'undefined' && this.suspended !== null) {
      toReturn['suspended'] = 'toApiJson' in this.suspended ? this.suspended.toApiJson() : this.suspended;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    return toReturn;
  }
}
class ServiceModel {
  static fromProto(proto) {
    let m = new ServiceModel();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Addon {
  static fromProto(proto) {
    let m = new Addon();
    m = Object.assign(m, proto);
    if (proto.endUserMarketing) {
      m.endUserMarketing = MarketingInformation.fromProto(proto.endUserMarketing);
    }
    if (proto.resellerMarketing) {
      m.resellerMarketing = MarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.suspended) {
      m.suspended = new Date(proto.suspended);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.bannerImage !== 'undefined') {
      toReturn['bannerImage'] = this.bannerImage;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.discoverable !== 'undefined') {
      toReturn['discoverable'] = this.discoverable;
    }
    if (typeof this.screenshots !== 'undefined') {
      toReturn['screenshots'] = this.screenshots;
    }
    if (typeof this.multipleActivations !== 'undefined') {
      toReturn['multipleActivations'] = this.multipleActivations;
    }
    if (typeof this.usesOrderForm !== 'undefined') {
      toReturn['usesOrderForm'] = this.usesOrderForm;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.activationRequiresApproval !== 'undefined') {
      toReturn['activationRequiresApproval'] = this.activationRequiresApproval;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.suspended !== 'undefined' && this.suspended !== null) {
      toReturn['suspended'] = 'toApiJson' in this.suspended ? this.suspended.toApiJson() : this.suspended;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    return toReturn;
  }
}
class IncludedCommonFormFields {
  static fromProto(proto) {
    let m = new IncludedCommonFormFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.businessAddress !== 'undefined') {
      toReturn['businessAddress'] = this.businessAddress;
    }
    if (typeof this.businessPhoneNumber !== 'undefined') {
      toReturn['businessPhoneNumber'] = this.businessPhoneNumber;
    }
    if (typeof this.businessAccountGroupId !== 'undefined') {
      toReturn['businessAccountGroupId'] = this.businessAccountGroupId;
    }
    if (typeof this.salespersonName !== 'undefined') {
      toReturn['salespersonName'] = this.salespersonName;
    }
    if (typeof this.salespersonPhoneNumber !== 'undefined') {
      toReturn['salespersonPhoneNumber'] = this.salespersonPhoneNumber;
    }
    if (typeof this.salespersonEmail !== 'undefined') {
      toReturn['salespersonEmail'] = this.salespersonEmail;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.contactPhoneNumber !== 'undefined') {
      toReturn['contactPhoneNumber'] = this.contactPhoneNumber;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    return toReturn;
  }
}
class MarketingInformation {
  static fromProto(proto) {
    let m = new MarketingInformation();
    m = Object.assign(m, proto);
    if (proto.faqs) {
      m.faqs = proto.faqs.map(FrequentlyAskedQuestions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    if (typeof this.faqs !== 'undefined' && this.faqs !== null) {
      toReturn['faqs'] = 'toApiJson' in this.faqs ? this.faqs.toApiJson() : this.faqs;
    }
    if (typeof this.files !== 'undefined') {
      toReturn['files'] = this.files;
    }
    return toReturn;
  }
}
class OrderForm {
  static fromProto(proto) {
    let m = new OrderForm();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = proto.orderForm.map(OrderFormField.fromProto);
    }
    if (proto.commonForm) {
      m.commonForm = IncludedCommonFormFields.fromProto(proto.commonForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.commonForm !== 'undefined' && this.commonForm !== null) {
      toReturn['commonForm'] = 'toApiJson' in this.commonForm ? this.commonForm.toApiJson() : this.commonForm;
    }
    if (typeof this.activationMessage !== 'undefined') {
      toReturn['activationMessage'] = this.activationMessage;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    return toReturn;
  }
}
class OrderFormField {
  static fromProto(proto) {
    let m = new OrderFormField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RetailPrice {
  static fromProto(proto) {
    let m = new RetailPrice();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue$7(FrequenciesFrequency, proto.billingFrequency);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$7(CurrenciesCurrency, proto.currency);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
let ActivatableApp$1 = class ActivatableApp {
  static fromProto(proto) {
    let m = new ActivatableApp();
    m = Object.assign(m, proto);
    if (proto.countryRestrictions) {
      m.countryRestrictions = PermissionLists$1.fromProto(proto.countryRestrictions);
    }
    if (proto.childActivatableApps) {
      m.childActivatableApps = proto.childActivatableApps.map(ActivatableApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.countryRestrictions !== 'undefined' && this.countryRestrictions !== null) {
      toReturn['countryRestrictions'] = 'toApiJson' in this.countryRestrictions ? this.countryRestrictions.toApiJson() : this.countryRestrictions;
    }
    if (typeof this.allowMultipleActivations !== 'undefined') {
      toReturn['allowMultipleActivations'] = this.allowMultipleActivations;
    }
    if (typeof this.childActivatableApps !== 'undefined' && this.childActivatableApps !== null) {
      toReturn['childActivatableApps'] = 'toApiJson' in this.childActivatableApps ? this.childActivatableApps.toApiJson() : this.childActivatableApps;
    }
    return toReturn;
  }
};
class AddProductToStoreRequest {
  static fromProto(proto) {
    let m = new AddProductToStoreRequest();
    m = Object.assign(m, proto);
    if (proto.retailPrice) {
      m.retailPrice = RetailPrice.fromProto(proto.retailPrice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.retailPrice !== 'undefined' && this.retailPrice !== null) {
      toReturn['retailPrice'] = 'toApiJson' in this.retailPrice ? this.retailPrice.toApiJson() : this.retailPrice;
    }
    if (typeof this.publishImmediately !== 'undefined') {
      toReturn['publishImmediately'] = this.publishImmediately;
    }
    return toReturn;
  }
}
class GetMultiAddonsByAppResponseAddonListContainer {
  static fromProto(proto) {
    let m = new GetMultiAddonsByAppResponseAddonListContainer();
    m = Object.assign(m, proto);
    if (proto.addons) {
      m.addons = proto.addons.map(Addon.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    return toReturn;
  }
}
class GetMultiAddonsByAppResponseAddonMapEntry {
  static fromProto(proto) {
    let m = new GetMultiAddonsByAppResponseAddonMapEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = GetMultiAddonsByAppResponseAddonListContainer.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class AddonOptions {
  static fromProto(proto) {
    let m = new AddonOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupAddonsWithParent !== 'undefined') {
      toReturn['groupAddonsWithParent'] = this.groupAddonsWithParent;
    }
    if (typeof this.displayNonDiscoverableAddons !== 'undefined') {
      toReturn['displayNonDiscoverableAddons'] = this.displayNonDiscoverableAddons;
    }
    return toReturn;
  }
}
class AppData {
  static fromProto(proto) {
    let m = new AppData();
    m = Object.assign(m, proto);
    if (proto.kindValues) {
      m.kindValues = proto.kindValues.map(KindValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.kindValues !== 'undefined' && this.kindValues !== null) {
      toReturn['kindValues'] = 'toApiJson' in this.kindValues ? this.kindValues.toApiJson() : this.kindValues;
    }
    return toReturn;
  }
}
class AreAppsDistributedToPartnerResponseAppDistributedContainer {
  static fromProto(proto) {
    let m = new AreAppsDistributedToPartnerResponseAppDistributedContainer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.isDistributed !== 'undefined') {
      toReturn['isDistributed'] = this.isDistributed;
    }
    if (typeof this.isSolelyDistributedToPartner !== 'undefined') {
      toReturn['isSolelyDistributedToPartner'] = this.isSolelyDistributedToPartner;
    }
    return toReturn;
  }
}
class ListAppDistributionStatusResponseAppDistributionStatus {
  static fromProto(proto) {
    let m = new ListAppDistributionStatusResponseAppDistributionStatus();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined') {
      toReturn['blacklist'] = this.blacklist;
    }
    if (typeof this.distributable !== 'undefined') {
      toReturn['distributable'] = this.distributable;
    }
    return toReturn;
  }
}
class GetMultiIsAppEnabledResponseAppEnablement {
  static fromProto(proto) {
    let m = new GetMultiIsAppEnabledResponseAppEnablement();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class AppSummary {
  static fromProto(proto) {
    let m = new AppSummary();
    m = Object.assign(m, proto);
    if (proto.vendorWholesale) {
      m.vendorWholesale = WholesalePrice.fromProto(proto.vendorWholesale);
    }
    if (proto.addons) {
      m.addons = proto.addons.map(AppSummary.fromProto);
    }
    if (proto.vendorRetailPrice) {
      m.vendorRetailPrice = VendorRetailPrice.fromProto(proto.vendorRetailPrice);
    }
    if (proto.wholesalePricingFromBilling) {
      m.wholesalePricingFromBilling = BillingWholesalePricing.fromProto(proto.wholesalePricingFromBilling);
    }
    if (proto.wholesalePrice) {
      m.wholesalePrice = ProductWholesalePrice.fromProto(proto.wholesalePrice);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.vendorWholesale !== 'undefined' && this.vendorWholesale !== null) {
      toReturn['vendorWholesale'] = 'toApiJson' in this.vendorWholesale ? this.vendorWholesale.toApiJson() : this.vendorWholesale;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    if (typeof this.vendorRetailPrice !== 'undefined' && this.vendorRetailPrice !== null) {
      toReturn['vendorRetailPrice'] = 'toApiJson' in this.vendorRetailPrice ? this.vendorRetailPrice.toApiJson() : this.vendorRetailPrice;
    }
    if (typeof this.wholesalePricingFromBilling !== 'undefined' && this.wholesalePricingFromBilling !== null) {
      toReturn['wholesalePricingFromBilling'] = 'toApiJson' in this.wholesalePricingFromBilling ? this.wholesalePricingFromBilling.toApiJson() : this.wholesalePricingFromBilling;
    }
    if (typeof this.wholesalePrice !== 'undefined' && this.wholesalePrice !== null) {
      toReturn['wholesalePrice'] = 'toApiJson' in this.wholesalePrice ? this.wholesalePrice.toApiJson() : this.wholesalePrice;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class AreAppsDistributedToPartnerRequest {
  static fromProto(proto) {
    let m = new AreAppsDistributedToPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class AreAppsDistributedToPartnerResponse {
  static fromProto(proto) {
    let m = new AreAppsDistributedToPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.areAppsDistributed) {
      m.areAppsDistributed = proto.areAppsDistributed.map(AreAppsDistributedToPartnerResponseAppDistributedContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.areAppsDistributed !== 'undefined' && this.areAppsDistributed !== null) {
      toReturn['areAppsDistributed'] = 'toApiJson' in this.areAppsDistributed ? this.areAppsDistributed.toApiJson() : this.areAppsDistributed;
    }
    return toReturn;
  }
}
class BillingWholesalePricing {
  static fromProto(proto) {
    let m = new BillingWholesalePricing();
    m = Object.assign(m, proto);
    if (proto.pricingType) {
      m.pricingType = enumStringToValue$4(ProductPricingType, proto.pricingType);
    }
    if (proto.pricingRules) {
      m.pricingRules = proto.pricingRules.map(ProductPricingRule.fromProto);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingType !== 'undefined') {
      toReturn['pricingType'] = this.pricingType;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricingRules !== 'undefined' && this.pricingRules !== null) {
      toReturn['pricingRules'] = 'toApiJson' in this.pricingRules ? this.pricingRules.toApiJson() : this.pricingRules;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.isStartingPrice !== 'undefined') {
      toReturn['isStartingPrice'] = this.isStartingPrice;
    }
    return toReturn;
  }
}
class BulkCopyPackageRequest {
  static fromProto(proto) {
    let m = new BulkCopyPackageRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = BulkCopyPackageRequestPackageSource.fromProto(proto.source);
    }
    if (proto.target) {
      m.target = PackageScope.fromProto(proto.target);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    if (typeof this.target !== 'undefined' && this.target !== null) {
      toReturn['target'] = 'toApiJson' in this.target ? this.target.toApiJson() : this.target;
    }
    return toReturn;
  }
}
class BulkCopyPackageResponse {
  static fromProto(proto) {
    let m = new BulkCopyPackageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Commitment {
  static fromProto(proto) {
    let m = new Commitment();
    m = Object.assign(m, proto);
    if (proto.initial) {
      m.initial = parseInt(proto.initial, 10);
    }
    if (proto.recurring) {
      m.recurring = parseInt(proto.recurring, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.initial !== 'undefined') {
      toReturn['initial'] = this.initial;
    }
    if (typeof this.recurring !== 'undefined') {
      toReturn['recurring'] = this.recurring;
    }
    return toReturn;
  }
}
class CopyPackageRequest {
  static fromProto(proto) {
    let m = new CopyPackageRequest();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.packageDestination) {
      m.packageDestination = PackageScope.fromProto(proto.packageDestination);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.publish !== 'undefined') {
      toReturn['publish'] = this.publish;
    }
    if (typeof this.packageDestination !== 'undefined' && this.packageDestination !== null) {
      toReturn['packageDestination'] = 'toApiJson' in this.packageDestination ? this.packageDestination.toApiJson() : this.packageDestination;
    }
    return toReturn;
  }
}
class CopyPackageResponse {
  static fromProto(proto) {
    let m = new CopyPackageResponse();
    m = Object.assign(m, proto);
    if (proto.failedScope) {
      m.failedScope = PackageScope.fromProto(proto.failedScope);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.failedScope !== 'undefined' && this.failedScope !== null) {
      toReturn['failedScope'] = 'toApiJson' in this.failedScope ? this.failedScope.toApiJson() : this.failedScope;
    }
    return toReturn;
  }
}
class Cost {
  static fromProto(proto) {
    let m = new Cost();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    return toReturn;
  }
}
class CreatePackageRequest {
  static fromProto(proto) {
    let m = new CreatePackageRequest();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.lineItems) {
      m.lineItems = LineItems.fromProto(proto.lineItems);
    }
    if (proto.marketAction) {
      m.marketAction = MarketAction.fromProto(proto.marketAction);
    }
    if (proto.pricingDisplayOption) {
      m.pricingDisplayOption = enumStringToValue$4(PricingDisplayOption, proto.pricingDisplayOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.headerImageUrl !== 'undefined') {
      toReturn['headerImageUrl'] = this.headerImageUrl;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.hideProductDetails !== 'undefined') {
      toReturn['hideProductDetails'] = this.hideProductDetails;
    }
    if (typeof this.hideProductIconsAndNames !== 'undefined') {
      toReturn['hideProductIconsAndNames'] = this.hideProductIconsAndNames;
    }
    if (typeof this.publishImmediately !== 'undefined') {
      toReturn['publishImmediately'] = this.publishImmediately;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.marketAction !== 'undefined' && this.marketAction !== null) {
      toReturn['marketAction'] = 'toApiJson' in this.marketAction ? this.marketAction.toApiJson() : this.marketAction;
    }
    if (typeof this.usesBillingPricing !== 'undefined') {
      toReturn['usesBillingPricing'] = this.usesBillingPricing;
    }
    if (typeof this.pricingDisplayOption !== 'undefined') {
      toReturn['pricingDisplayOption'] = this.pricingDisplayOption;
    }
    return toReturn;
  }
}
class CreatePackageResponse {
  static fromProto(proto) {
    let m = new CreatePackageResponse();
    m = Object.assign(m, proto);
    if (proto.package) {
      m.package = Package.fromProto(proto.package);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.package !== 'undefined' && this.package !== null) {
      toReturn['package'] = 'toApiJson' in this.package ? this.package.toApiJson() : this.package;
    }
    return toReturn;
  }
}
class DeletePackageRequest {
  static fromProto(proto) {
    let m = new DeletePackageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    return toReturn;
  }
}
class DisableAppForPartnerRequest {
  static fromProto(proto) {
    let m = new DisableAppForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class DiscoverableAppParent {
  static fromProto(proto) {
    let m = new DiscoverableAppParent();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class DiscoverableAppSummary {
  static fromProto(proto) {
    let m = new DiscoverableAppSummary();
    m = Object.assign(m, proto);
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue$4(FrequenciesFrequency, proto.billingFrequency);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$4(CurrenciesCurrency, proto.currency);
    }
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$4(LmiCategories, v));
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.appData) {
      m.appData = AppData.fromProto(proto.appData);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = VendorRetailPrice.fromProto(proto.suggestedRetailPrice);
    }
    if (proto.parent) {
      m.parent = DiscoverableAppParent.fromProto(proto.parent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.appData !== 'undefined' && this.appData !== null) {
      toReturn['appData'] = 'toApiJson' in this.appData ? this.appData.toApiJson() : this.appData;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined' && this.suggestedRetailPrice !== null) {
      toReturn['suggestedRetailPrice'] = 'toApiJson' in this.suggestedRetailPrice ? this.suggestedRetailPrice.toApiJson() : this.suggestedRetailPrice;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    if (typeof this.parent !== 'undefined' && this.parent !== null) {
      toReturn['parent'] = 'toApiJson' in this.parent ? this.parent.toApiJson() : this.parent;
    }
    return toReturn;
  }
}
class EnableAppForPartnerRequest {
  static fromProto(proto) {
    let m = new EnableAppForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class GetMultiAddonsByAppRequest {
  static fromProto(proto) {
    let m = new GetMultiAddonsByAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class GetMultiAddonsByAppResponse {
  static fromProto(proto) {
    let m = new GetMultiAddonsByAppResponse();
    m = Object.assign(m, proto);
    if (proto.addonMap) {
      m.addonMap = Object.keys(proto.addonMap).reduce((obj, k) => {
        obj[k] = GetMultiAddonsByAppResponseAddonListContainer.fromProto(proto.addonMap[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonMap !== 'undefined' && this.addonMap !== null) {
      toReturn['addonMap'] = 'toApiJson' in this.addonMap ? this.addonMap.toApiJson() : this.addonMap;
    }
    return toReturn;
  }
}
class GetMultiAddonsRequest {
  static fromProto(proto) {
    let m = new GetMultiAddonsRequest();
    m = Object.assign(m, proto);
    if (proto.addonKeys) {
      m.addonKeys = proto.addonKeys.map(AddonKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonKeys !== 'undefined' && this.addonKeys !== null) {
      toReturn['addonKeys'] = 'toApiJson' in this.addonKeys ? this.addonKeys.toApiJson() : this.addonKeys;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class GetMultiAddonsResponse {
  static fromProto(proto) {
    let m = new GetMultiAddonsResponse();
    m = Object.assign(m, proto);
    if (proto.addons) {
      m.addons = proto.addons.map(Addon.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    return toReturn;
  }
}
class GetMultiIsAppEnabledRequest {
  static fromProto(proto) {
    let m = new GetMultiIsAppEnabledRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class GetMultiIsAppEnabledResponse {
  static fromProto(proto) {
    let m = new GetMultiIsAppEnabledResponse();
    m = Object.assign(m, proto);
    if (proto.appEnablement) {
      m.appEnablement = proto.appEnablement.map(GetMultiIsAppEnabledResponseAppEnablement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appEnablement !== 'undefined' && this.appEnablement !== null) {
      toReturn['appEnablement'] = 'toApiJson' in this.appEnablement ? this.appEnablement.toApiJson() : this.appEnablement;
    }
    return toReturn;
  }
}
class GetMultiPackageRequest {
  static fromProto(proto) {
    let m = new GetMultiPackageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class GetMultiPackageResponse {
  static fromProto(proto) {
    let m = new GetMultiPackageResponse();
    m = Object.assign(m, proto);
    if (proto.packageContainers) {
      m.packageContainers = proto.packageContainers.map(GetMultiPackageResponsePackageContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageContainers !== 'undefined' && this.packageContainers !== null) {
      toReturn['packageContainers'] = 'toApiJson' in this.packageContainers ? this.packageContainers.toApiJson() : this.packageContainers;
    }
    return toReturn;
  }
}
class GetMultiPartnerAppEnablementStatusRequest {
  static fromProto(proto) {
    let m = new GetMultiPartnerAppEnablementStatusRequest();
    m = Object.assign(m, proto);
    if (proto.partnerAppRequest) {
      m.partnerAppRequest = proto.partnerAppRequest.map(PartnerAppRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerAppRequest !== 'undefined' && this.partnerAppRequest !== null) {
      toReturn['partnerAppRequest'] = 'toApiJson' in this.partnerAppRequest ? this.partnerAppRequest.toApiJson() : this.partnerAppRequest;
    }
    return toReturn;
  }
}
class GetMultiPartnerAppEnablementStatusResponse {
  static fromProto(proto) {
    let m = new GetMultiPartnerAppEnablementStatusResponse();
    m = Object.assign(m, proto);
    if (proto.partnerAppResponse) {
      m.partnerAppResponse = proto.partnerAppResponse.map(PartnerAppResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerAppResponse !== 'undefined' && this.partnerAppResponse !== null) {
      toReturn['partnerAppResponse'] = 'toApiJson' in this.partnerAppResponse ? this.partnerAppResponse.toApiJson() : this.partnerAppResponse;
    }
    return toReturn;
  }
}
class GetMultiProductsRequest {
  static fromProto(proto) {
    let m = new GetMultiProductsRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class GetMultiProductsResponse {
  static fromProto(proto) {
    let m = new GetMultiProductsResponse();
    m = Object.assign(m, proto);
    if (proto.products) {
      m.products = proto.products.map(GetMultiProductsResponseProductContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    return toReturn;
  }
}
class HideArchivedPackageRequest {
  static fromProto(proto) {
    let m = new HideArchivedPackageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    return toReturn;
  }
}
class IsAppDistributedToPartnerRequest {
  static fromProto(proto) {
    let m = new IsAppDistributedToPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class IsAppDistributedToPartnerResponse {
  static fromProto(proto) {
    let m = new IsAppDistributedToPartnerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isDistributed !== 'undefined') {
      toReturn['isDistributed'] = this.isDistributed;
    }
    return toReturn;
  }
}
class KindValues {
  static fromProto(proto) {
    let m = new KindValues();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ListActivatableAppsRequest {
  static fromProto(proto) {
    let m = new ListActivatableAppsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class ListActivatableAppsResponse {
  static fromProto(proto) {
    let m = new ListActivatableAppsResponse();
    m = Object.assign(m, proto);
    if (proto.activatableApps) {
      m.activatableApps = proto.activatableApps.map(ActivatableApp$1.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activatableApps !== 'undefined' && this.activatableApps !== null) {
      toReturn['activatableApps'] = 'toApiJson' in this.activatableApps ? this.activatableApps.toApiJson() : this.activatableApps;
    }
    return toReturn;
  }
}
class ListAddonsRequest {
  static fromProto(proto) {
    let m = new ListAddonsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class ListAddonsResponse {
  static fromProto(proto) {
    let m = new ListAddonsResponse();
    m = Object.assign(m, proto);
    if (proto.addons) {
      m.addons = proto.addons.map(Addon.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListAppDistributionStatusRequest {
  static fromProto(proto) {
    let m = new ListAppDistributionStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListAppDistributionStatusResponse {
  static fromProto(proto) {
    let m = new ListAppDistributionStatusResponse();
    m = Object.assign(m, proto);
    if (proto.appDistributionStatuses) {
      m.appDistributionStatuses = proto.appDistributionStatuses.map(ListAppDistributionStatusResponseAppDistributionStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appDistributionStatuses !== 'undefined' && this.appDistributionStatuses !== null) {
      toReturn['appDistributionStatuses'] = 'toApiJson' in this.appDistributionStatuses ? this.appDistributionStatuses.toApiJson() : this.appDistributionStatuses;
    }
    return toReturn;
  }
}
class ListAvailableAppsRequest {
  static fromProto(proto) {
    let m = new ListAvailableAppsRequest();
    m = Object.assign(m, proto);
    if (proto.tagFilters) {
      m.tagFilters = proto.tagFilters.map(Tag.fromProto);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    if (typeof this.tagFilters !== 'undefined' && this.tagFilters !== null) {
      toReturn['tagFilters'] = 'toApiJson' in this.tagFilters ? this.tagFilters.toApiJson() : this.tagFilters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListAvailableAppsResponse {
  static fromProto(proto) {
    let m = new ListAvailableAppsResponse();
    m = Object.assign(m, proto);
    if (proto.availableAppsSummaries) {
      m.availableAppsSummaries = proto.availableAppsSummaries.map(AppSummary.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.availableAppsSummaries !== 'undefined' && this.availableAppsSummaries !== null) {
      toReturn['availableAppsSummaries'] = 'toApiJson' in this.availableAppsSummaries ? this.availableAppsSummaries.toApiJson() : this.availableAppsSummaries;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListDiscoverableAppSuggestionsRequest {
  static fromProto(proto) {
    let m = new ListDiscoverableAppSuggestionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListDiscoverableAppSuggestionsResponse {
  static fromProto(proto) {
    let m = new ListDiscoverableAppSuggestionsResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(ListDiscoverableAppSuggestionsResponseSuggestion.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class ListDiscoverableAppsRequest {
  static fromProto(proto) {
    let m = new ListDiscoverableAppsRequest();
    m = Object.assign(m, proto);
    if (proto.tagFilters) {
      m.tagFilters = proto.tagFilters.map(Tag.fromProto);
    }
    if (proto.sortOrder) {
      m.sortOrder = enumStringToValue$4(DiscoverProductSortOrderType, proto.sortOrder);
    }
    if (proto.addonOptions) {
      m.addonOptions = AddonOptions.fromProto(proto.addonOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    if (typeof this.tagFilters !== 'undefined' && this.tagFilters !== null) {
      toReturn['tagFilters'] = 'toApiJson' in this.tagFilters ? this.tagFilters.toApiJson() : this.tagFilters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortOrder !== 'undefined') {
      toReturn['sortOrder'] = this.sortOrder;
    }
    if (typeof this.addonOptions !== 'undefined' && this.addonOptions !== null) {
      toReturn['addonOptions'] = 'toApiJson' in this.addonOptions ? this.addonOptions.toApiJson() : this.addonOptions;
    }
    return toReturn;
  }
}
class ListDiscoverableAppsResponse {
  static fromProto(proto) {
    let m = new ListDiscoverableAppsResponse();
    m = Object.assign(m, proto);
    if (proto.discoverableAppSummary) {
      m.discoverableAppSummary = proto.discoverableAppSummary.map(DiscoverableAppSummary.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discoverableAppSummary !== 'undefined' && this.discoverableAppSummary !== null) {
      toReturn['discoverableAppSummary'] = 'toApiJson' in this.discoverableAppSummary ? this.discoverableAppSummary.toApiJson() : this.discoverableAppSummary;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListDistributedAppIdsRequest {
  static fromProto(proto) {
    let m = new ListDistributedAppIdsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListDistributedAppIdsRequestListDistributedAppIdsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListDistributedAppIdsRequestListDistributedAppIdsRequestFilters {
  static fromProto(proto) {
    let m = new ListDistributedAppIdsRequestListDistributedAppIdsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.appTypes) {
      m.appTypes = proto.appTypes.map(v => enumStringToValue$4(AppType$1, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appTypes !== 'undefined') {
      toReturn['appTypes'] = this.appTypes;
    }
    return toReturn;
  }
}
class ListDistributedAppIdsResponse {
  static fromProto(proto) {
    let m = new ListDistributedAppIdsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class ListPackageIDsForProductRequest {
  static fromProto(proto) {
    let m = new ListPackageIDsForProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ListPackageIDsForProductResponse {
  static fromProto(proto) {
    let m = new ListPackageIDsForProductResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class ListPackagesRequest {
  static fromProto(proto) {
    let m = new ListPackagesRequest();
    m = Object.assign(m, proto);
    if (proto.lmiCategory) {
      m.lmiCategory = enumStringToValue$4(LmiCategories, proto.lmiCategory);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$4(StatusesStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.lmiCategory !== 'undefined') {
      toReturn['lmiCategory'] = this.lmiCategory;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.sort !== 'undefined') {
      toReturn['sort'] = this.sort;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.includeTotalResults !== 'undefined') {
      toReturn['includeTotalResults'] = this.includeTotalResults;
    }
    if (typeof this.filterTerm !== 'undefined') {
      toReturn['filterTerm'] = this.filterTerm;
    }
    return toReturn;
  }
}
class ListPackagesResponse {
  static fromProto(proto) {
    let m = new ListPackagesResponse();
    m = Object.assign(m, proto);
    if (proto.packages) {
      m.packages = proto.packages.map(Package.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListPartnerAppEnablementStatusRequest {
  static fromProto(proto) {
    let m = new ListPartnerAppEnablementStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListPartnerAppEnablementStatusResponse {
  static fromProto(proto) {
    let m = new ListPartnerAppEnablementStatusResponse();
    m = Object.assign(m, proto);
    if (proto.partnerAppResponse) {
      m.partnerAppResponse = proto.partnerAppResponse.map(PartnerAppResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerAppResponse !== 'undefined' && this.partnerAppResponse !== null) {
      toReturn['partnerAppResponse'] = 'toApiJson' in this.partnerAppResponse ? this.partnerAppResponse.toApiJson() : this.partnerAppResponse;
    }
    return toReturn;
  }
}
class ListProductFilter {
  static fromProto(proto) {
    let m = new ListProductFilter();
    m = Object.assign(m, proto);
    if (proto.state) {
      m.state = enumStringToValue$4(StateFilterOptions, proto.state);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    return toReturn;
  }
}
class ListProductsRequest {
  static fromProto(proto) {
    let m = new ListProductsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListProductFilter.fromProto(proto.filters);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.whitelabelOverrideKey !== 'undefined') {
      toReturn['whitelabelOverrideKey'] = this.whitelabelOverrideKey;
    }
    return toReturn;
  }
}
class ListProductsResponse {
  static fromProto(proto) {
    let m = new ListProductsResponse();
    m = Object.assign(m, proto);
    if (proto.products) {
      m.products = proto.products.map(Product.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class GetMultiPackageResponsePackageContainer {
  static fromProto(proto) {
    let m = new GetMultiPackageResponsePackageContainer();
    m = Object.assign(m, proto);
    if (proto.package) {
      m.package = Package.fromProto(proto.package);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.package !== 'undefined' && this.package !== null) {
      toReturn['package'] = 'toApiJson' in this.package ? this.package.toApiJson() : this.package;
    }
    return toReturn;
  }
}
class PackageIdContainer {
  static fromProto(proto) {
    let m = new PackageIdContainer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class PackageScope {
  static fromProto(proto) {
    let m = new PackageScope();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class BulkCopyPackageRequestPackageSource {
  static fromProto(proto) {
    let m = new BulkCopyPackageRequestPackageSource();
    m = Object.assign(m, proto);
    if (proto.packageIdsContainer) {
      m.packageIdsContainer = PackageIdContainer.fromProto(proto.packageIdsContainer);
    }
    if (proto.scope) {
      m.scope = PackageScope.fromProto(proto.scope);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageIdsContainer !== 'undefined' && this.packageIdsContainer !== null) {
      toReturn['packageIdsContainer'] = 'toApiJson' in this.packageIdsContainer ? this.packageIdsContainer.toApiJson() : this.packageIdsContainer;
    }
    if (typeof this.scope !== 'undefined' && this.scope !== null) {
      toReturn['scope'] = 'toApiJson' in this.scope ? this.scope.toApiJson() : this.scope;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PartnerAppRequest {
  static fromProto(proto) {
    let m = new PartnerAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class PartnerAppResponse {
  static fromProto(proto) {
    let m = new PartnerAppResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$4(AppEnablementStatusesAppEnablementStatus, proto.status);
    }
    if (proto.updateEvents) {
      m.updateEvents = proto.updateEvents.map(UpdateEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.updateEvents !== 'undefined' && this.updateEvents !== null) {
      toReturn['updateEvents'] = 'toApiJson' in this.updateEvents ? this.updateEvents.toApiJson() : this.updateEvents;
    }
    return toReturn;
  }
}
class GetMultiProductsResponseProductContainer {
  static fromProto(proto) {
    let m = new GetMultiProductsResponseProductContainer();
    m = Object.assign(m, proto);
    if (proto.product) {
      m.product = Product.fromProto(proto.product);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.product !== 'undefined' && this.product !== null) {
      toReturn['product'] = 'toApiJson' in this.product ? this.product.toApiJson() : this.product;
    }
    return toReturn;
  }
}
class ProductPricingRule {
  static fromProto(proto) {
    let m = new ProductPricingRule();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.minUnits) {
      m.minUnits = parseInt(proto.minUnits, 10);
    }
    if (proto.maxUnits) {
      m.maxUnits = parseInt(proto.maxUnits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.minUnits !== 'undefined') {
      toReturn['minUnits'] = this.minUnits;
    }
    if (typeof this.maxUnits !== 'undefined') {
      toReturn['maxUnits'] = this.maxUnits;
    }
    return toReturn;
  }
}
class ProductWholesalePrice {
  static fromProto(proto) {
    let m = new ProductWholesalePrice();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.isStartingAt !== 'undefined') {
      toReturn['isStartingAt'] = this.isStartingAt;
    }
    if (typeof this.shouldContactSales !== 'undefined') {
      toReturn['shouldContactSales'] = this.shouldContactSales;
    }
    if (typeof this.priceDisplaySku !== 'undefined') {
      toReturn['priceDisplaySku'] = this.priceDisplaySku;
    }
    return toReturn;
  }
}
class ListDiscoverableAppSuggestionsResponseSuggestion {
  static fromProto(proto) {
    let m = new ListDiscoverableAppSuggestionsResponseSuggestion();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appName !== 'undefined') {
      toReturn['appName'] = this.appName;
    }
    return toReturn;
  }
}
class Tag {
  static fromProto(proto) {
    let m = new Tag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class UpdateEvent {
  static fromProto(proto) {
    let m = new UpdateEvent();
    m = Object.assign(m, proto);
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.status) {
      m.status = enumStringToValue$4(AppEnablementStatusesAppEnablementStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class UpdatePackageOperation {
  static fromProto(proto) {
    let m = new UpdatePackageOperation();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.lineItems) {
      m.lineItems = LineItems.fromProto(proto.lineItems);
    }
    if (proto.status) {
      m.status = enumStringToValue$4(StatusesStatus, proto.status);
    }
    if (proto.marketAction) {
      m.marketAction = MarketAction.fromProto(proto.marketAction);
    }
    if (proto.pricingDisplayOption) {
      m.pricingDisplayOption = enumStringToValue$4(PricingDisplayOption, proto.pricingDisplayOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.headerImageUrl !== 'undefined') {
      toReturn['headerImageUrl'] = this.headerImageUrl;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.hideProductDetails !== 'undefined') {
      toReturn['hideProductDetails'] = this.hideProductDetails;
    }
    if (typeof this.hideProductIconsAndNames !== 'undefined') {
      toReturn['hideProductIconsAndNames'] = this.hideProductIconsAndNames;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.marketAction !== 'undefined' && this.marketAction !== null) {
      toReturn['marketAction'] = 'toApiJson' in this.marketAction ? this.marketAction.toApiJson() : this.marketAction;
    }
    if (typeof this.usesBillingPricing !== 'undefined') {
      toReturn['usesBillingPricing'] = this.usesBillingPricing;
    }
    if (typeof this.pricingDisplayOption !== 'undefined') {
      toReturn['pricingDisplayOption'] = this.pricingDisplayOption;
    }
    if (typeof this.iconUrlV2 !== 'undefined') {
      toReturn['iconUrlV2'] = this.iconUrlV2;
    }
    if (typeof this.headerImageUrlV2 !== 'undefined') {
      toReturn['headerImageUrlV2'] = this.headerImageUrlV2;
    }
    return toReturn;
  }
}
class UpdatePackageRequest {
  static fromProto(proto) {
    let m = new UpdatePackageRequest();
    m = Object.assign(m, proto);
    if (proto.updatePackageOperations) {
      m.updatePackageOperations = proto.updatePackageOperations.map(UpdatePackageOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.updatePackageOperations !== 'undefined' && this.updatePackageOperations !== null) {
      toReturn['updatePackageOperations'] = 'toApiJson' in this.updatePackageOperations ? this.updatePackageOperations.toApiJson() : this.updatePackageOperations;
    }
    return toReturn;
  }
}
class UpdatePackageResponse {
  static fromProto(proto) {
    let m = new UpdatePackageResponse();
    m = Object.assign(m, proto);
    if (proto.package) {
      m.package = Package.fromProto(proto.package);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.package !== 'undefined' && this.package !== null) {
      toReturn['package'] = 'toApiJson' in this.package ? this.package.toApiJson() : this.package;
    }
    return toReturn;
  }
}
class VendorRetailPrice {
  static fromProto(proto) {
    let m = new VendorRetailPrice();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.editionPrice !== 'undefined') {
      toReturn['editionPrice'] = this.editionPrice;
    }
    return toReturn;
  }
}
class WholesalePrice {
  static fromProto(proto) {
    let m = new WholesalePrice();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddMultiToShoppingCartRequest {
  static fromProto(proto) {
    let m = new AddMultiToShoppingCartRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(AddMultiToShoppingCartRequestItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class AddToShoppingCartRequest {
  static fromProto(proto) {
    let m = new AddToShoppingCartRequest();
    m = Object.assign(m, proto);
    if (proto.itemType) {
      m.itemType = enumStringToValue$3(ShoppingCartItemType, proto.itemType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ClearShoppingCartRequest {
  static fromProto(proto) {
    let m = new ClearShoppingCartRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetShoppingCartRequest {
  static fromProto(proto) {
    let m = new GetShoppingCartRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class IsShoppingCartEnabledRequest {
  static fromProto(proto) {
    let m = new IsShoppingCartEnabledRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    return toReturn;
  }
}
class IsShoppingCartEnabledResponse {
  static fromProto(proto) {
    let m = new IsShoppingCartEnabledResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class AddMultiToShoppingCartRequestItem {
  static fromProto(proto) {
    let m = new AddMultiToShoppingCartRequestItem();
    m = Object.assign(m, proto);
    if (proto.itemType) {
      m.itemType = enumStringToValue$3(ShoppingCartItemType, proto.itemType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class RemoveFromShoppingCartRequest {
  static fromProto(proto) {
    let m = new RemoveFromShoppingCartRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    return toReturn;
  }
}
class RemoveMultiFromShoppingCartRequest {
  static fromProto(proto) {
    let m = new RemoveMultiFromShoppingCartRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class ShoppingCart {
  static fromProto(proto) {
    let m = new ShoppingCart();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(ShoppingCartShoppingCartItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class ShoppingCartShoppingCartItem {
  static fromProto(proto) {
    let m = new ShoppingCartShoppingCartItem();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.itemType) {
      m.itemType = enumStringToValue$3(ShoppingCartItemType, proto.itemType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ShoppingCartResponse {
  static fromProto(proto) {
    let m = new ShoppingCartResponse();
    m = Object.assign(m, proto);
    if (proto.cart) {
      m.cart = ShoppingCart.fromProto(proto.cart);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cart !== 'undefined' && this.cart !== null) {
      toReturn['cart'] = 'toApiJson' in this.cart ? this.cart.toApiJson() : this.cart;
    }
    return toReturn;
  }
}
class UpdateItemQuantityRequest {
  static fromProto(proto) {
    let m = new UpdateItemQuantityRequest();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddToStoreRequest {
  static fromProto(proto) {
    let m = new AddToStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class AddToStoresRequest {
  static fromProto(proto) {
    let m = new AddToStoresRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.storeIds !== 'undefined') {
      toReturn['storeIds'] = this.storeIds;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    return toReturn;
  }
}
class Category {
  static fromProto(proto) {
    let m = new Category();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.categoryName !== 'undefined') {
      toReturn['categoryName'] = this.categoryName;
    }
    if (typeof this.visibleInStore !== 'undefined') {
      toReturn['visibleInStore'] = this.visibleInStore;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    return toReturn;
  }
}
class CheckProductVisibilityRequest {
  static fromProto(proto) {
    let m = new CheckProductVisibilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.productReferenceId !== 'undefined') {
      toReturn['productReferenceId'] = this.productReferenceId;
    }
    return toReturn;
  }
}
class CheckProductVisibilityResponse {
  static fromProto(proto) {
    let m = new CheckProductVisibilityResponse();
    m = Object.assign(m, proto);
    if (proto.productVisibilty) {
      m.productVisibilty = Object.keys(proto.productVisibilty).reduce((obj, k) => {
        obj[k] = proto.productVisibilty[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productVisibilty !== 'undefined' && this.productVisibilty !== null) {
      toReturn['productVisibilty'] = 'toApiJson' in this.productVisibilty ? this.productVisibilty.toApiJson() : this.productVisibilty;
    }
    return toReturn;
  }
}
class CreateStoreCategoryRequest {
  static fromProto(proto) {
    let m = new CreateStoreCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateStoreCategoryResponse {
  static fromProto(proto) {
    let m = new CreateStoreCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class DeleteStoreCategoryRequest {
  static fromProto(proto) {
    let m = new DeleteStoreCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    return toReturn;
  }
}
class EnableCustomCategoriesForStoreRequest {
  static fromProto(proto) {
    let m = new EnableCustomCategoriesForStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    return toReturn;
  }
}
class EnableCustomCategoriesForStoreResponse {
  static fromProto(proto) {
    let m = new EnableCustomCategoriesForStoreResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class GetCategoriesForStoreRequest {
  static fromProto(proto) {
    let m = new GetCategoriesForStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    return toReturn;
  }
}
class GetCategoriesForStoreResponse {
  static fromProto(proto) {
    let m = new GetCategoriesForStoreResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class GetMultiStorePricePreviewsRequest {
  static fromProto(proto) {
    let m = new GetMultiStorePricePreviewsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    return toReturn;
  }
}
class GetMultiStorePricePreviewsResponse {
  static fromProto(proto) {
    let m = new GetMultiStorePricePreviewsResponse();
    m = Object.assign(m, proto);
    if (proto.productPreviews) {
      m.productPreviews = proto.productPreviews.map(ProductPricePreviews.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productPreviews !== 'undefined' && this.productPreviews !== null) {
      toReturn['productPreviews'] = 'toApiJson' in this.productPreviews ? this.productPreviews.toApiJson() : this.productPreviews;
    }
    return toReturn;
  }
}
class GetPublicStoreThemeRequest {
  static fromProto(proto) {
    let m = new GetPublicStoreThemeRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    return toReturn;
  }
}
class GetPublicStoreThemeResponse {
  static fromProto(proto) {
    let m = new GetPublicStoreThemeResponse();
    m = Object.assign(m, proto);
    if (proto.publicStoreTheme) {
      m.publicStoreTheme = PublicStoreTheme.fromProto(proto.publicStoreTheme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publicStoreTheme !== 'undefined' && this.publicStoreTheme !== null) {
      toReturn['publicStoreTheme'] = 'toApiJson' in this.publicStoreTheme ? this.publicStoreTheme.toApiJson() : this.publicStoreTheme;
    }
    return toReturn;
  }
}
class GetStoreRequest {
  static fromProto(proto) {
    let m = new GetStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    return toReturn;
  }
}
class GetStoreResponse {
  static fromProto(proto) {
    let m = new GetStoreResponse();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.publicStoreSalesPersonId !== 'undefined') {
      toReturn['publicStoreSalesPersonId'] = this.publicStoreSalesPersonId;
    }
    if (typeof this.useCustomCategories !== 'undefined') {
      toReturn['useCustomCategories'] = this.useCustomCategories;
    }
    if (typeof this.categoryOrder !== 'undefined') {
      toReturn['categoryOrder'] = this.categoryOrder;
    }
    return toReturn;
  }
}
class GetStoreWithCategoriesRequest {
  static fromProto(proto) {
    let m = new GetStoreWithCategoriesRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.bypassCache !== 'undefined') {
      toReturn['bypassCache'] = this.bypassCache;
    }
    if (typeof this.getLegacyLmiCategories !== 'undefined') {
      toReturn['getLegacyLmiCategories'] = this.getLegacyLmiCategories;
    }
    return toReturn;
  }
}
class GetStoreWithCategoriesResponse {
  static fromProto(proto) {
    let m = new GetStoreWithCategoriesResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    if (typeof this.publicStoreSalesPersonId !== 'undefined') {
      toReturn['publicStoreSalesPersonId'] = this.publicStoreSalesPersonId;
    }
    return toReturn;
  }
}
class HasPartnerSetStoreOrderRequest {
  static fromProto(proto) {
    let m = new HasPartnerSetStoreOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class HasPartnerSetStoreOrderResponse {
  static fromProto(proto) {
    let m = new HasPartnerSetStoreOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.result !== 'undefined') {
      toReturn['result'] = this.result;
    }
    return toReturn;
  }
}
class ListCategoriesForPackageRequest {
  static fromProto(proto) {
    let m = new ListCategoriesForPackageRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    return toReturn;
  }
}
class ListCategoriesForPackageResponse {
  static fromProto(proto) {
    let m = new ListCategoriesForPackageResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class ListProductsInStoreFilters {
  static fromProto(proto) {
    let m = new ListProductsInStoreFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListProductsInStoreRequest {
  static fromProto(proto) {
    let m = new ListProductsInStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filters) {
      m.filters = ListProductsInStoreFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListProductsInStoreResponse {
  static fromProto(proto) {
    let m = new ListProductsInStoreResponse();
    m = Object.assign(m, proto);
    if (proto.storeProducts) {
      m.storeProducts = proto.storeProducts.map(StoreProduct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeProducts !== 'undefined' && this.storeProducts !== null) {
      toReturn['storeProducts'] = 'toApiJson' in this.storeProducts ? this.storeProducts.toApiJson() : this.storeProducts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListStorePricePreviewsRequest {
  static fromProto(proto) {
    let m = new ListStorePricePreviewsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    return toReturn;
  }
}
class ListStorePricePreviewsResponse {
  static fromProto(proto) {
    let m = new ListStorePricePreviewsResponse();
    m = Object.assign(m, proto);
    if (proto.previews) {
      m.previews = proto.previews.map(StorePricePreviews.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.previews !== 'undefined' && this.previews !== null) {
      toReturn['previews'] = 'toApiJson' in this.previews ? this.previews.toApiJson() : this.previews;
    }
    return toReturn;
  }
}
class ListStoreProductVisibilitySummariesRequest {
  static fromProto(proto) {
    let m = new ListStoreProductVisibilitySummariesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListStoreProductVisibilitySummariesResponse {
  static fromProto(proto) {
    let m = new ListStoreProductVisibilitySummariesResponse();
    m = Object.assign(m, proto);
    if (proto.summaries) {
      m.summaries = Object.keys(proto.summaries).reduce((obj, k) => {
        obj[k] = ListStoreProductVisibilitySummariesResponseStoreProductVisibilitySummary.fromProto(proto.summaries[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.summaries !== 'undefined' && this.summaries !== null) {
      toReturn['summaries'] = 'toApiJson' in this.summaries ? this.summaries.toApiJson() : this.summaries;
    }
    return toReturn;
  }
}
class ListVisibleAddonsForProductRequest {
  static fromProto(proto) {
    let m = new ListVisibleAddonsForProductRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListVisibleAddonsForProductResponse {
  static fromProto(proto) {
    let m = new ListVisibleAddonsForProductResponse();
    m = Object.assign(m, proto);
    if (proto.storeProducts) {
      m.storeProducts = proto.storeProducts.map(StoreProduct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeProducts !== 'undefined' && this.storeProducts !== null) {
      toReturn['storeProducts'] = 'toApiJson' in this.storeProducts ? this.storeProducts.toApiJson() : this.storeProducts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ProductPricePreviews {
  static fromProto(proto) {
    let m = new ProductPricePreviews();
    m = Object.assign(m, proto);
    if (proto.storePreviews) {
      m.storePreviews = proto.storePreviews.map(StorePricePreviews.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.storePreviews !== 'undefined' && this.storePreviews !== null) {
      toReturn['storePreviews'] = 'toApiJson' in this.storePreviews ? this.storePreviews.toApiJson() : this.storePreviews;
    }
    return toReturn;
  }
}
class CheckProductVisibilityResponseProductVisibiltyEntry {
  static fromProto(proto) {
    let m = new CheckProductVisibilityResponseProductVisibiltyEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class PublicStoreTheme {
  static fromProto(proto) {
    let m = new PublicStoreTheme();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logoBarColor !== 'undefined') {
      toReturn['logoBarColor'] = this.logoBarColor;
    }
    if (typeof this.backgroundColor !== 'undefined') {
      toReturn['backgroundColor'] = this.backgroundColor;
    }
    if (typeof this.primaryFontColor !== 'undefined') {
      toReturn['primaryFontColor'] = this.primaryFontColor;
    }
    if (typeof this.secondaryFontColor !== 'undefined') {
      toReturn['secondaryFontColor'] = this.secondaryFontColor;
    }
    if (typeof this.accentColor !== 'undefined') {
      toReturn['accentColor'] = this.accentColor;
    }
    if (typeof this.primaryCategoryColor !== 'undefined') {
      toReturn['primaryCategoryColor'] = this.primaryCategoryColor;
    }
    if (typeof this.secondaryCategoryColor !== 'undefined') {
      toReturn['secondaryCategoryColor'] = this.secondaryCategoryColor;
    }
    return toReturn;
  }
}
class RemoveFromStoreRequest {
  static fromProto(proto) {
    let m = new RemoveFromStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.productReferenceId !== 'undefined') {
      toReturn['productReferenceId'] = this.productReferenceId;
    }
    return toReturn;
  }
}
class SetCategoriesForPackageRequest {
  static fromProto(proto) {
    let m = new SetCategoriesForPackageRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    return toReturn;
  }
}
class SetPackagesInCategoryRequest {
  static fromProto(proto) {
    let m = new SetPackagesInCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    return toReturn;
  }
}
class SetStoreCategoryOrderRequest {
  static fromProto(proto) {
    let m = new SetStoreCategoryOrderRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.orderedCategoryIds !== 'undefined') {
      toReturn['orderedCategoryIds'] = this.orderedCategoryIds;
    }
    return toReturn;
  }
}
class StoreIdentifier {
  static fromProto(proto) {
    let m = new StoreIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class StorePricePreview {
  static fromProto(proto) {
    let m = new StorePricePreview();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$2(FrequenciesFrequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.editionName !== 'undefined') {
      toReturn['editionName'] = this.editionName;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
class StorePricePreviews {
  static fromProto(proto) {
    let m = new StorePricePreviews();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.prices) {
      m.prices = proto.prices.map(StorePricePreview.fromProto);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$2(CurrenciesCurrency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.storeName !== 'undefined') {
      toReturn['storeName'] = this.storeName;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    return toReturn;
  }
}
class StoreProduct {
  static fromProto(proto) {
    let m = new StoreProduct();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$2(LmiCategories, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.headerImageUrl !== 'undefined') {
      toReturn['headerImageUrl'] = this.headerImageUrl;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    return toReturn;
  }
}
class ListStoreProductVisibilitySummariesResponseStoreProductVisibilitySummary {
  static fromProto(proto) {
    let m = new ListStoreProductVisibilitySummariesResponseStoreProductVisibilitySummary();
    m = Object.assign(m, proto);
    if (proto.numStoresVisible) {
      m.numStoresVisible = parseInt(proto.numStoresVisible, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.numStoresVisible !== 'undefined') {
      toReturn['numStoresVisible'] = this.numStoresVisible;
    }
    return toReturn;
  }
}
class ListStoreProductVisibilitySummariesResponseSummariesEntry {
  static fromProto(proto) {
    let m = new ListStoreProductVisibilitySummariesResponseSummariesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ListStoreProductVisibilitySummariesResponseStoreProductVisibilitySummary.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UpdatePublicStoreThemeRequest {
  static fromProto(proto) {
    let m = new UpdatePublicStoreThemeRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.publicStoreTheme) {
      m.publicStoreTheme = PublicStoreTheme.fromProto(proto.publicStoreTheme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.publicStoreTheme !== 'undefined' && this.publicStoreTheme !== null) {
      toReturn['publicStoreTheme'] = 'toApiJson' in this.publicStoreTheme ? this.publicStoreTheme.toApiJson() : this.publicStoreTheme;
    }
    return toReturn;
  }
}
class UpdateStoreCategoryRequest {
  static fromProto(proto) {
    let m = new UpdateStoreCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.visibleInStore !== 'undefined') {
      toReturn['visibleInStore'] = this.visibleInStore;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateStoreRequest {
  static fromProto(proto) {
    let m = new UpdateStoreRequest();
    m = Object.assign(m, proto);
    if (proto.storeId) {
      m.storeId = StoreIdentifier.fromProto(proto.storeId);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.storeId !== 'undefined' && this.storeId !== null) {
      toReturn['storeId'] = 'toApiJson' in this.storeId ? this.storeId.toApiJson() : this.storeId;
    }
    if (typeof this.publicStoreSalesPersonId !== 'undefined') {
      toReturn['publicStoreSalesPersonId'] = this.publicStoreSalesPersonId;
    }
    if (typeof this.useCustomCategories !== 'undefined') {
      toReturn['useCustomCategories'] = this.useCustomCategories;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConvertRetailPricesForMarketRequest {
  static fromProto(proto) {
    let m = new ConvertRetailPricesForMarketRequest();
    m = Object.assign(m, proto);
    if (proto.partnerMarket) {
      m.partnerMarket = PartnerMarketContainer.fromProto(proto.partnerMarket);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerMarket !== 'undefined' && this.partnerMarket !== null) {
      toReturn['partnerMarket'] = 'toApiJson' in this.partnerMarket ? this.partnerMarket.toApiJson() : this.partnerMarket;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.conversionRate !== 'undefined') {
      toReturn['conversionRate'] = this.conversionRate;
    }
    return toReturn;
  }
}
class CreateOrUpdateRetailPriceRequest {
  static fromProto(proto) {
    let m = new CreateOrUpdateRetailPriceRequest();
    m = Object.assign(m, proto);
    if (proto.retailPrice) {
      m.retailPrice = RetailPrice.fromProto(proto.retailPrice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.retailPrice !== 'undefined' && this.retailPrice !== null) {
      toReturn['retailPrice'] = 'toApiJson' in this.retailPrice ? this.retailPrice.toApiJson() : this.retailPrice;
    }
    return toReturn;
  }
}
class DeleteRetailPriceRequest {
  static fromProto(proto) {
    let m = new DeleteRetailPriceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetMultiRetailPriceRequest {
  static fromProto(proto) {
    let m = new GetMultiRetailPriceRequest();
    m = Object.assign(m, proto);
    if (proto.partnerMarket) {
      m.partnerMarket = PartnerMarketContainer.fromProto(proto.partnerMarket);
    }
    if (proto.productIds) {
      m.productIds = proto.productIds.map(ProductIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerMarket !== 'undefined' && this.partnerMarket !== null) {
      toReturn['partnerMarket'] = 'toApiJson' in this.partnerMarket ? this.partnerMarket.toApiJson() : this.partnerMarket;
    }
    if (typeof this.productIds !== 'undefined' && this.productIds !== null) {
      toReturn['productIds'] = 'toApiJson' in this.productIds ? this.productIds.toApiJson() : this.productIds;
    }
    return toReturn;
  }
}
class GetMultiRetailPriceResponse {
  static fromProto(proto) {
    let m = new GetMultiRetailPriceResponse();
    m = Object.assign(m, proto);
    if (proto.retailPrices) {
      m.retailPrices = proto.retailPrices.map(GetMultiRetailPriceResponseRetailPriceResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.retailPrices !== 'undefined' && this.retailPrices !== null) {
      toReturn['retailPrices'] = 'toApiJson' in this.retailPrices ? this.retailPrices.toApiJson() : this.retailPrices;
    }
    return toReturn;
  }
}
class GetRetailPriceRequest {
  static fromProto(proto) {
    let m = new GetRetailPriceRequest();
    m = Object.assign(m, proto);
    if (proto.partnerMarket) {
      m.partnerMarket = PartnerMarketContainer.fromProto(proto.partnerMarket);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerMarket !== 'undefined' && this.partnerMarket !== null) {
      toReturn['partnerMarket'] = 'toApiJson' in this.partnerMarket ? this.partnerMarket.toApiJson() : this.partnerMarket;
    }
    if (typeof this.dontUseMsrp !== 'undefined') {
      toReturn['dontUseMsrp'] = this.dontUseMsrp;
    }
    return toReturn;
  }
}
class GetRetailPriceResponse {
  static fromProto(proto) {
    let m = new GetRetailPriceResponse();
    m = Object.assign(m, proto);
    if (proto.retailPrice) {
      m.retailPrice = RetailPrice.fromProto(proto.retailPrice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.retailPrice !== 'undefined' && this.retailPrice !== null) {
      toReturn['retailPrice'] = 'toApiJson' in this.retailPrice ? this.retailPrice.toApiJson() : this.retailPrice;
    }
    return toReturn;
  }
}
class PartnerMarketContainer {
  static fromProto(proto) {
    let m = new PartnerMarketContainer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ProductIdentifier {
  static fromProto(proto) {
    let m = new ProductIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class GetMultiRetailPriceResponseRetailPriceResponse {
  static fromProto(proto) {
    let m = new GetMultiRetailPriceResponseRetailPriceResponse();
    m = Object.assign(m, proto);
    if (proto.productId) {
      m.productId = ProductIdentifier.fromProto(proto.productId);
    }
    if (proto.retailPrice) {
      m.retailPrice = RetailPrice.fromProto(proto.retailPrice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined' && this.productId !== null) {
      toReturn['productId'] = 'toApiJson' in this.productId ? this.productId.toApiJson() : this.productId;
    }
    if (typeof this.retailPrice !== 'undefined' && this.retailPrice !== null) {
      toReturn['retailPrice'] = 'toApiJson' in this.retailPrice ? this.retailPrice.toApiJson() : this.retailPrice;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BuyItNowLink {
  static fromProto(proto) {
    let m = new BuyItNowLink();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.linkId !== 'undefined') {
      toReturn['linkId'] = this.linkId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    return toReturn;
  }
}
class GenerateBuyItNowLinkRequest {
  static fromProto(proto) {
    let m = new GenerateBuyItNowLinkRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    return toReturn;
  }
}
class GenerateBuyItNowLinkResponse {
  static fromProto(proto) {
    let m = new GenerateBuyItNowLinkResponse();
    m = Object.assign(m, proto);
    if (proto.link) {
      m.link = BuyItNowLink.fromProto(proto.link);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined' && this.link !== null) {
      toReturn['link'] = 'toApiJson' in this.link ? this.link.toApiJson() : this.link;
    }
    if (typeof this.shortenedUrl !== 'undefined') {
      toReturn['shortenedUrl'] = this.shortenedUrl;
    }
    return toReturn;
  }
}
class GetBuyItNowLinkByLinkIDRequest {
  static fromProto(proto) {
    let m = new GetBuyItNowLinkByLinkIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.linkId !== 'undefined') {
      toReturn['linkId'] = this.linkId;
    }
    return toReturn;
  }
}
class GetBuyItNowLinkByLinkIDResponse {
  static fromProto(proto) {
    let m = new GetBuyItNowLinkByLinkIDResponse();
    m = Object.assign(m, proto);
    if (proto.link) {
      m.link = BuyItNowLink.fromProto(proto.link);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined' && this.link !== null) {
      toReturn['link'] = 'toApiJson' in this.link ? this.link.toApiJson() : this.link;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'marketplace-packages-api.vendasta-local.com',
  'test': '',
  'demo': 'marketplace-packages-api-demo.apigateway.co',
  'prod': 'marketplace-packages-api-prod.apigateway.co',
  'production': 'marketplace-packages-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AppPartnerSettingsApiService = /*#__PURE__*/(() => {
  class AppPartnerSettingsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getRetailPrice(r) {
      const request = r.toApiJson ? r : new GetRetailPriceRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.AppPartnerSettings/GetRetailPrice", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailPriceResponse.fromProto(resp)));
    }
    getMultiRetailPrice(r) {
      const request = r.toApiJson ? r : new GetMultiRetailPriceRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.AppPartnerSettings/GetMultiRetailPrice", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiRetailPriceResponse.fromProto(resp)));
    }
    createOrUpdateRetailPrice(r) {
      const request = r.toApiJson ? r : new CreateOrUpdateRetailPriceRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.AppPartnerSettings/CreateOrUpdateRetailPrice", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailPriceResponse.fromProto(resp)));
    }
    deleteRetailPrice(r) {
      const request = r.toApiJson ? r : new DeleteRetailPriceRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.AppPartnerSettings/DeleteRetailPrice", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    convertRetailPricesForMarket(r) {
      const request = r.toApiJson ? r : new ConvertRetailPricesForMarketRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.AppPartnerSettings/ConvertRetailPricesForMarket", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AppPartnerSettingsApiService.ɵfac = function AppPartnerSettingsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AppPartnerSettingsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AppPartnerSettingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppPartnerSettingsApiService,
    factory: AppPartnerSettingsApiService.ɵfac,
    providedIn: 'root'
  });
  return AppPartnerSettingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BuyItNowApiService = /*#__PURE__*/(() => {
  class BuyItNowApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateBuyItNowLink(r) {
      const request = r.toApiJson ? r : new GenerateBuyItNowLinkRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.BuyItNow/GenerateBuyItNowLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateBuyItNowLinkResponse.fromProto(resp)));
    }
    getBuyItNowLinkByLinkId(r) {
      const request = r.toApiJson ? r : new GetBuyItNowLinkByLinkIDRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.BuyItNow/GetBuyItNowLinkByLinkID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBuyItNowLinkByLinkIDResponse.fromProto(resp)));
    }
  }
  BuyItNowApiService.ɵfac = function BuyItNowApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BuyItNowApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BuyItNowApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BuyItNowApiService,
    factory: BuyItNowApiService.ɵfac,
    providedIn: 'root'
  });
  return BuyItNowApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MarketplacePackagesApiService = /*#__PURE__*/(() => {
  class MarketplacePackagesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listProducts(r) {
      const request = r.toApiJson ? r : new ListProductsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListProductsResponse.fromProto(resp)));
    }
    getMultiProducts(r) {
      const request = r.toApiJson ? r : new GetMultiProductsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiProductsResponse.fromProto(resp)));
    }
    listPackages(r) {
      const request = r.toApiJson ? r : new ListPackagesRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListPackages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPackagesResponse.fromProto(resp)));
    }
    getMultiAddons(r) {
      const request = r.toApiJson ? r : new GetMultiAddonsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAddonsResponse.fromProto(resp)));
    }
    listAddons(r) {
      const request = r.toApiJson ? r : new ListAddonsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAddonsResponse.fromProto(resp)));
    }
    createPackage(r) {
      const request = r.toApiJson ? r : new CreatePackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/CreatePackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePackageResponse.fromProto(resp)));
    }
    updatePackage(r) {
      const request = r.toApiJson ? r : new UpdatePackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/UpdatePackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePackageResponse.fromProto(resp)));
    }
    deletePackage(r) {
      const request = r.toApiJson ? r : new DeletePackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/DeletePackage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    hideArchivedPackage(r) {
      const request = r.toApiJson ? r : new HideArchivedPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/HideArchivedPackage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiPackages(r) {
      const request = r.toApiJson ? r : new GetMultiPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiPackages", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPackageResponse.fromProto(resp)));
    }
    listAppDistributionStatus(r) {
      const request = r.toApiJson ? r : new ListAppDistributionStatusRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListAppDistributionStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppDistributionStatusResponse.fromProto(resp)));
    }
    listDiscoverableApps(r) {
      const request = r.toApiJson ? r : new ListDiscoverableAppsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListDiscoverableApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDiscoverableAppsResponse.fromProto(resp)));
    }
    listDiscoverableAppSuggestions(r) {
      const request = r.toApiJson ? r : new ListDiscoverableAppSuggestionsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListDiscoverableAppSuggestions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDiscoverableAppSuggestionsResponse.fromProto(resp)));
    }
    listAvailableApps(r) {
      const request = r.toApiJson ? r : new ListAvailableAppsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListAvailableApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAvailableAppsResponse.fromProto(resp)));
    }
    listActivatableApps(r) {
      const request = r.toApiJson ? r : new ListActivatableAppsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListActivatableApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivatableAppsResponse.fromProto(resp)));
    }
    getMultiAddonsByApp(r) {
      const request = r.toApiJson ? r : new GetMultiAddonsByAppRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiAddonsByApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAddonsByAppResponse.fromProto(resp)));
    }
    listDistributedAppIds(r) {
      const request = r.toApiJson ? r : new ListDistributedAppIdsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListDistributedAppIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDistributedAppIdsResponse.fromProto(resp)));
    }
    isAppDistributedToPartner(r) {
      const request = r.toApiJson ? r : new IsAppDistributedToPartnerRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/IsAppDistributedToPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsAppDistributedToPartnerResponse.fromProto(resp)));
    }
    areAppsDistributedToPartner(r) {
      const request = r.toApiJson ? r : new AreAppsDistributedToPartnerRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/AreAppsDistributedToPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => AreAppsDistributedToPartnerResponse.fromProto(resp)));
    }
    copyPackage(r) {
      const request = r.toApiJson ? r : new CopyPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/CopyPackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => CopyPackageResponse.fromProto(resp)));
    }
    bulkCopyPackage(r) {
      const request = r.toApiJson ? r : new BulkCopyPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/BulkCopyPackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkCopyPackageResponse.fromProto(resp)));
    }
    getMultiPartnerAppEnablementStatus(r) {
      const request = r.toApiJson ? r : new GetMultiPartnerAppEnablementStatusRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiPartnerAppEnablementStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPartnerAppEnablementStatusResponse.fromProto(resp)));
    }
    listPartnerAppEnablementStatus(r) {
      const request = r.toApiJson ? r : new ListPartnerAppEnablementStatusRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListPartnerAppEnablementStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerAppEnablementStatusResponse.fromProto(resp)));
    }
    getMultiIsAppEnabled(r) {
      const request = r.toApiJson ? r : new GetMultiIsAppEnabledRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/GetMultiIsAppEnabled", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiIsAppEnabledResponse.fromProto(resp)));
    }
    disableAppForPartner(r) {
      const request = r.toApiJson ? r : new DisableAppForPartnerRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/DisableAppForPartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    enableAppForPartner(r) {
      const request = r.toApiJson ? r : new EnableAppForPartnerRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/EnableAppForPartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addProductToStore(r) {
      const request = r.toApiJson ? r : new AddProductToStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/AddProductToStore", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPackageIDsForProduct(r) {
      const request = r.toApiJson ? r : new ListPackageIDsForProductRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplacePackages/ListPackageIDsForProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPackageIDsForProductResponse.fromProto(resp)));
    }
  }
  MarketplacePackagesApiService.ɵfac = function MarketplacePackagesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MarketplacePackagesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MarketplacePackagesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketplacePackagesApiService,
    factory: MarketplacePackagesApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketplacePackagesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MarketplaceStoreApiService = /*#__PURE__*/(() => {
  class MarketplaceStoreApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getStore(r) {
      const request = r.toApiJson ? r : new GetStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/GetStore", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetStoreResponse.fromProto(resp)));
    }
    updateStore(r) {
      const request = r.toApiJson ? r : new UpdateStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/UpdateStore", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setStoreCategoryOrder(r) {
      const request = r.toApiJson ? r : new SetStoreCategoryOrderRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/SetStoreCategoryOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createStoreCategory(r) {
      const request = r.toApiJson ? r : new CreateStoreCategoryRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/CreateStoreCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateStoreCategoryResponse.fromProto(resp)));
    }
    deleteStoreCategory(r) {
      const request = r.toApiJson ? r : new DeleteStoreCategoryRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/DeleteStoreCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCategoriesForStore(r) {
      const request = r.toApiJson ? r : new GetCategoriesForStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/GetCategoriesForStore", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoriesForStoreResponse.fromProto(resp)));
    }
    updateStoreCategory(r) {
      const request = r.toApiJson ? r : new UpdateStoreCategoryRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/UpdateStoreCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCategoriesForPackage(r) {
      const request = r.toApiJson ? r : new ListCategoriesForPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/ListCategoriesForPackage", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCategoriesForPackageResponse.fromProto(resp)));
    }
    setPackagesInCategory(r) {
      const request = r.toApiJson ? r : new SetPackagesInCategoryRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/SetPackagesInCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setCategoriesForPackage(r) {
      const request = r.toApiJson ? r : new SetCategoriesForPackageRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/SetCategoriesForPackage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getStoreWithCategories(r) {
      const request = r.toApiJson ? r : new GetStoreWithCategoriesRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/GetStoreWithCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetStoreWithCategoriesResponse.fromProto(resp)));
    }
    enableCustomCategoriesForStore(r) {
      const request = r.toApiJson ? r : new EnableCustomCategoriesForStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/EnableCustomCategoriesForStore", request.toApiJson(), this.apiOptions()).pipe(map(resp => EnableCustomCategoriesForStoreResponse.fromProto(resp)));
    }
    getPublicStoreTheme(r) {
      const request = r.toApiJson ? r : new GetPublicStoreThemeRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/GetPublicStoreTheme", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPublicStoreThemeResponse.fromProto(resp)));
    }
    updatePublicStoreTheme(r) {
      const request = r.toApiJson ? r : new UpdatePublicStoreThemeRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/UpdatePublicStoreTheme", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addToStore(r) {
      const request = r.toApiJson ? r : new AddToStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/AddToStore", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addToStores(r) {
      const request = r.toApiJson ? r : new AddToStoresRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/AddToStores", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeFromStore(r) {
      const request = r.toApiJson ? r : new RemoveFromStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/RemoveFromStore", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    checkProductVisibility(r) {
      const request = r.toApiJson ? r : new CheckProductVisibilityRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/CheckProductVisibility", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckProductVisibilityResponse.fromProto(resp)));
    }
    listProductsInStore(r) {
      const request = r.toApiJson ? r : new ListProductsInStoreRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/ListProductsInStore", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListProductsInStoreResponse.fromProto(resp)));
    }
    listVisibleAddonsForProduct(r) {
      const request = r.toApiJson ? r : new ListVisibleAddonsForProductRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/ListVisibleAddonsForProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListVisibleAddonsForProductResponse.fromProto(resp)));
    }
    listStorePricePreviews(r) {
      const request = r.toApiJson ? r : new ListStorePricePreviewsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/ListStorePricePreviews", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListStorePricePreviewsResponse.fromProto(resp)));
    }
    getMultiStorePricePreviews(r) {
      const request = r.toApiJson ? r : new GetMultiStorePricePreviewsRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/GetMultiStorePricePreviews", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiStorePricePreviewsResponse.fromProto(resp)));
    }
    listStoreProductVisibilitySummaries(r) {
      const request = r.toApiJson ? r : new ListStoreProductVisibilitySummariesRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/ListStoreProductVisibilitySummaries", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListStoreProductVisibilitySummariesResponse.fromProto(resp)));
    }
    hasPartnerSetStoreOrder(r) {
      const request = r.toApiJson ? r : new HasPartnerSetStoreOrderRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.MarketplaceStore/HasPartnerSetStoreOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => HasPartnerSetStoreOrderResponse.fromProto(resp)));
    }
  }
  MarketplaceStoreApiService.ɵfac = function MarketplaceStoreApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MarketplaceStoreApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MarketplaceStoreApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketplaceStoreApiService,
    factory: MarketplaceStoreApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketplaceStoreApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ShoppingCartApiService = /*#__PURE__*/(() => {
  class ShoppingCartApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getShoppingCart(r) {
      const request = r.toApiJson ? r : new GetShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/GetShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    addToShoppingCart(r) {
      const request = r.toApiJson ? r : new AddToShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/AddToShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    addMultiToShoppingCart(r) {
      const request = r.toApiJson ? r : new AddMultiToShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/AddMultiToShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    updateItemQuantity(r) {
      const request = r.toApiJson ? r : new UpdateItemQuantityRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/UpdateItemQuantity", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    removeFromShoppingCart(r) {
      const request = r.toApiJson ? r : new RemoveFromShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/RemoveFromShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    removeMultiFromShoppingCart(r) {
      const request = r.toApiJson ? r : new RemoveMultiFromShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/RemoveMultiFromShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    clearShoppingCart(r) {
      const request = r.toApiJson ? r : new ClearShoppingCartRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/ClearShoppingCart", request.toApiJson(), this.apiOptions()).pipe(map(resp => ShoppingCartResponse.fromProto(resp)));
    }
    isShoppingCartEnabled(r) {
      const request = r.toApiJson ? r : new IsShoppingCartEnabledRequest(r);
      return this.http.post(this._host + "/marketplace_packages.v1.ShoppingCartService/IsShoppingCartEnabled", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsShoppingCartEnabledResponse.fromProto(resp)));
    }
  }
  ShoppingCartApiService.ɵfac = function ShoppingCartApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ShoppingCartApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ShoppingCartApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ShoppingCartApiService,
    factory: ShoppingCartApiService.ɵfac,
    providedIn: 'root'
  });
  return ShoppingCartApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerAppEnablementStatusService = /*#__PURE__*/(() => {
  class PartnerAppEnablementStatusService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    listPartnerAppEnablementStatus(partnerId) {
      const request = new ListPartnerAppEnablementStatusRequest({
        partnerId: partnerId
      });
      const response = this.apiService.listPartnerAppEnablementStatus(request);
      return response.pipe(map(res => res.partnerAppResponse));
    }
    enableAppForPartner(partnerId, appId, origin) {
      const request = new EnableAppForPartnerRequest({
        partnerId: partnerId,
        appId: appId,
        origin: origin
      });
      const response = this.apiService.enableAppForPartner(request);
      return response;
    }
    disableAppForPartner(partnerId, appId, origin) {
      const request = new DisableAppForPartnerRequest({
        partnerId: partnerId,
        appId: appId,
        origin: origin
      });
      const response = this.apiService.disableAppForPartner(request);
      return response;
    }
    getMultiIsAppEnabled(appIds) {
      const request = new GetMultiIsAppEnabledRequest({
        appIds: appIds
      });
      const response = this.apiService.getMultiIsAppEnabled(request);
      return response.pipe(map(res => res.appEnablement));
    }
    getMultiPartnerAppEnablementStatus(partnerAppIds) {
      const request = new GetMultiPartnerAppEnablementStatusRequest({
        partnerAppRequest: partnerAppIds
      });
      const response = this.apiService.getMultiPartnerAppEnablementStatus(request);
      return response.pipe(map(res => res.partnerAppResponse));
    }
  }
  PartnerAppEnablementStatusService.ɵfac = function PartnerAppEnablementStatusService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerAppEnablementStatusService)(i0.ɵɵinject(MarketplacePackagesApiService));
  };
  PartnerAppEnablementStatusService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerAppEnablementStatusService,
    factory: PartnerAppEnablementStatusService.ɵfac,
    providedIn: 'root'
  });
  return PartnerAppEnablementStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PackageService = /*#__PURE__*/(() => {
  class PackageService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    copyPackage(packageId, partnerId, marketIds, contactSales, name, status, currency, price, additionalPrice, frequency, additionalFrequency, isStartingPrice, isAdditionalStartingPrice) {
      const request = new CopyPackageRequest({
        packageId: packageId,
        name: name,
        publish: status ? status.toLowerCase() === 'publish' : false
      });
      if (contactSales) {
        price = -1;
        frequency = 'MONTHLY';
      }
      if (price && frequency || additionalPrice && additionalFrequency) {
        request.pricing = new Pricing();
        if (currency) {
          request.pricing.currency = CurrenciesCurrency[currency.toUpperCase()];
        }
        if (price && frequency) {
          request.pricing.prices = [new Price({
            price: price,
            frequency: FrequenciesFrequency[frequency.toUpperCase()],
            isStartingPrice: isStartingPrice
          })];
        }
        if (additionalPrice && additionalFrequency) {
          request.pricing.prices = (request.pricing.prices ? request.pricing.prices : []).concat(new Price({
            price: additionalPrice,
            frequency: FrequenciesFrequency[additionalFrequency.toUpperCase()],
            isStartingPrice: isAdditionalStartingPrice
          }));
        }
      }
      request.packageDestination = new PackageScope({
        partnerId: partnerId,
        marketIds: marketIds
      });
      return this.apiService.copyPackage(request);
    }
    loadAllPackages(partnerId, statuses, marketId = 'default', sort = false, pageSize = 600, cursor = 'MA==', lmiCategory) {
      return this.apiService.listPackages(new ListPackagesRequest({
        partnerId: partnerId,
        statuses: statuses,
        marketId: marketId,
        lmiCategory: lmiCategory,
        sort: sort,
        pageSize: pageSize,
        cursor: cursor
      }));
    }
    list(partnerId, statuses, marketId = 'default', pageSize = 600, cursor = 'MA==', lmiCategory, includeTotalResults, filterTerm) {
      return this.apiService.listPackages(new ListPackagesRequest({
        partnerId: partnerId,
        statuses: statuses,
        marketId: marketId,
        lmiCategory: lmiCategory,
        pageSize: pageSize,
        cursor: cursor,
        includeTotalResults: includeTotalResults,
        filterTerm: filterTerm
      }));
    }
    getMulti(packageIds) {
      if (!packageIds || packageIds.length === 0) {
        throw Error('Must provide at least one package id for GetMulti.');
      }
      const request = new GetMultiPackageRequest({
        packageIds: packageIds
      });
      const response = this.apiService.getMultiPackages(request);
      return response.pipe(map(resp => {
        return resp.packageContainers.map(container => container.package);
      }));
    }
    /**
     * DEPRECATED
     * @deprecated please use the getAllAppDistributionStatuses method in the apps.service.ts file
    */
    listAppDistributionStatus(pageSize = 0, cursor = 'MA==') {
      return this.apiService.listAppDistributionStatus(new ListAppDistributionStatusRequest({
        pageSize: pageSize,
        cursor: cursor
      }));
    }
    /**
     * @params packageId is the id of the package that the status will be set for. Status is the status the package
     * will be mutated to have.
     * @returns the mutated package
     * @throws httpErrorResponse
    */
    setStatus(packageId, status) {
      const req = new UpdatePackageRequest({
        packageId: packageId,
        updatePackageOperations: [new UpdatePackageOperation({
          status: status
        })]
      });
      return this.apiService.updatePackage(req).pipe(map(resp => resp.package));
    }
    /**
     * @params fields that make up a package including name, tagline and lineItems
     * @returns the created package
     * @throws httpErrorResponse
    */
    create(partnerId, marketId, name, tagline, iconUrl, headerImageUrl, content, lineItems, pricing, hideProductIconsAndNames, hideProductDetails, publishImmediately, marketAction, usesBillingPricing, pricingDisplayOption) {
      const req = new CreatePackageRequest({
        partnerId: partnerId,
        marketId: marketId,
        name: name,
        tagline: tagline,
        iconUrl: iconUrl,
        headerImageUrl: headerImageUrl,
        content: content,
        lineItems: new LineItems({
          lineItems: lineItems
        }),
        pricing: pricing,
        hideProductDetails: hideProductDetails,
        hideProductIconsAndNames: hideProductIconsAndNames,
        publishImmediately: publishImmediately,
        marketAction: marketAction,
        usesBillingPricing: usesBillingPricing,
        pricingDisplayOption: pricingDisplayOption
      });
      return this.apiService.createPackage(req).pipe(map(resp => resp.package));
    }
    /**
     * @params fields that make up a package including name, tagline and lineItems
     * @returns the created package
     * @throws httpErrorResponse if the api fails
    */
    update(packageId, name, tagline, iconUrl, headerImageUrl, content, lineItems, pricing, hideProductIconsAndNames, hideProductDetails, marketAction, usesBillingPricing, pricingDisplayOption) {
      const req = new UpdatePackageRequest({
        packageId: packageId,
        updatePackageOperations: [new UpdatePackageOperation({
          name: name
        }), new UpdatePackageOperation({
          tagline: tagline
        }), new UpdatePackageOperation({
          iconUrlV2: iconUrl
        }), new UpdatePackageOperation({
          headerImageUrlV2: headerImageUrl
        }), new UpdatePackageOperation({
          content: content
        }), new UpdatePackageOperation({
          lineItems: new LineItems({
            lineItems: lineItems
          })
        }), new UpdatePackageOperation({
          pricing: pricing
        }), new UpdatePackageOperation({
          hideProductIconsAndNames: hideProductIconsAndNames
        }), new UpdatePackageOperation({
          hideProductDetails: hideProductDetails
        }), new UpdatePackageOperation({
          marketAction: marketAction
        }), new UpdatePackageOperation({
          usesBillingPricing: usesBillingPricing
        }), new UpdatePackageOperation({
          pricingDisplayOption: pricingDisplayOption
        })]
      });
      return this.apiService.updatePackage(req).pipe(map(resp => resp.package));
    }
    hideArchivedPackage(packageId) {
      const req = new HideArchivedPackageRequest({
        packageId
      });
      return this.apiService.hideArchivedPackage(req);
    }
    /**
     * @params the id of the package to be fetched
     * @returns the package corresponding to the id passed
     * @throws httpErrorResponse containing a 412 if the packageID isn't passed,
     * 404 if the package isn't found, or 500 if there is some other api error
    */
    get(packageId) {
      if (!packageId) {
        of(new HttpErrorResponse({
          status: 412,
          statusText: 'package with id' + packageId + 'doesn\'t exist'
        }));
      }
      const req = new GetMultiPackageRequest({
        packageIds: [packageId]
      });
      return this.apiService.getMultiPackages(req).pipe(map(res => res.packageContainers || []), map(cont => {
        if (cont && cont.length && cont[0].package) {
          return cont[0].package;
        }
        throw new HttpErrorResponse({
          status: 404,
          statusText: 'package with id' + packageId + 'doesn\'t exist'
        });
      }), shareReplay(1));
    }
    listPackageIDsForProduct(partnerId, marketId, appId, editionId) {
      const request = new ListPackageIDsForProductRequest({
        partnerId: partnerId,
        marketId: marketId,
        appId: appId,
        editionId: editionId
      });
      return this.apiService.listPackageIDsForProduct(request).pipe(map(response => response.packageIds));
    }
    /**
     * @params fields containing information about the product to be made into a package and the retail price to be set
     * @returns empty response
     * @throws httpErrorResponse
    */
    addProductToStore(partnerId, marketId, appId, editionId, retailPrice, publishImmediately) {
      const request = new AddProductToStoreRequest({
        partnerId: partnerId,
        marketId: marketId,
        appId: appId,
        editionId: editionId,
        retailPrice: retailPrice,
        publishImmediately: publishImmediately
      });
      return this.apiService.addProductToStore(request);
    }
  }
  PackageService.ɵfac = function PackageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PackageService)(i0.ɵɵinject(MarketplacePackagesApiService));
  };
  PackageService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PackageService,
    factory: PackageService.ɵfac,
    providedIn: 'root'
  });
  return PackageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductService = /*#__PURE__*/(() => {
  class ProductService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    loadAllProducts(partnerId, pageSize = 600, cursor = 'MA==', marketId = '', filters = new ListProductFilter({
      approved: false
    }), whitelabelOverrideKey) {
      return this.apiService.listProducts(new ListProductsRequest({
        partnerId: partnerId,
        pageSize: pageSize,
        cursor: cursor,
        marketId: marketId,
        filters: filters,
        whitelabelOverrideKey: whitelabelOverrideKey
      }));
    }
    getMultiProducts(partnerId, productIds, marketId, whitelabelOverrideKey) {
      return this.apiService.getMultiProducts(new GetMultiProductsRequest({
        partnerId: partnerId,
        productIds: productIds,
        marketId: marketId,
        whitelabelOverrideKey: whitelabelOverrideKey
      }));
    }
  }
  ProductService.ɵfac = function ProductService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProductService)(i0.ɵɵinject(MarketplacePackagesApiService));
  };
  ProductService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductService,
    factory: ProductService.ɵfac,
    providedIn: 'root'
  });
  return ProductService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PermissionLists {}
function convertActivatableApps(genApps) {
  if (genApps.length === 0) {
    return [];
  }
  return genApps.map(app => {
    return ActivatableApp.fromApi(app);
  });
}
class ActivatableApp {
  static fromApi(data) {
    const obj = new ActivatableApp();
    obj.appId = data.appId;
    obj.name = data.name;
    obj.headerImage = data.headerImage;
    obj.tagline = data.tagline;
    obj.icon = data.icon;
    obj.countryRestrictions = data.countryRestrictions;
    if (data.childActivatableApps != null) {
      obj.childActivatableApps = convertActivatableApps(data.childActivatableApps);
    } else {
      obj.childActivatableApps = [];
    }
    return obj;
  }
}
var AppType = /*#__PURE__*/function (AppType) {
  AppType[AppType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  AppType[AppType["APP"] = 1] = "APP";
  AppType[AppType["ADDON"] = 2] = "ADDON";
  AppType[AppType["CUSTOM_PRODUCT"] = 3] = "CUSTOM_PRODUCT";
  return AppType;
}(AppType || {});
let MarketplaceAppService = /*#__PURE__*/(() => {
  class MarketplaceAppService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    /*
        @params:
          - partnerId: represents the partner to get discoverable app summary list for
          - pageSize (optional): the number of results to return per request
          - cursor (optional): the cursor to begin paging from
          - marketId (optional): the market context that the partner user is operating in
          - whitelabelOverrideKey (optional): override the current whitelabel configuration
        @returns: an observable containing a discoverable app summary list, next cursor, and an indicator of whether there are more results
        @throws: an HttpError if the client is unable to fetch the data
      */
    listDiscoverableApps(partnerId, pageSize, cursor, marketId, whitelabelOverrideKey, tagFilters, searchTerm, sortOrder, addonOptions) {
      return this.apiService.listDiscoverableApps(new ListDiscoverableAppsRequest({
        partnerId: partnerId,
        pageSize: pageSize,
        cursor: cursor,
        marketId: marketId,
        whitelabelOverrideKey: whitelabelOverrideKey,
        tagFilters: tagFilters,
        searchTerm: searchTerm,
        sortOrder: sortOrder,
        addonOptions: addonOptions
      }));
    }
    /*
      @params:
        - partnerId: represents the partner to get discoverable app summary list for
        - searchTerm: the term to suggest apps for
        - pageSize (optional): the number of results to return per request
      @returns: an observable containing a list of app suggestions
      @throws: an HttpError if the client is unable to fetch the data
    */
    listDiscoverableAppSuggestions(partnerId, searchTerm, pageSize) {
      return this.apiService.listDiscoverableAppSuggestions(new ListDiscoverableAppSuggestionsRequest({
        partnerId: partnerId,
        pageSize: pageSize,
        searchTerm: searchTerm
      }));
    }
    /*
      @params:
        - partnerId: represents the partner to get app summary list for
        - tagFilters: represents the tags the list should be filtered by
        - pageSize (optional): the number of results to return per request
        - cursor (optional): the cursor to begin paging from
        - whitelabelOverrideKey (optional): override the current whitelabel configuration
      @returns: an observable containing a app summary list, next cursor, and an indicator of whether there are more results
      @throws: an HttpError if the client is unable to fetch the data
    */
    listAvailableApps(partnerId, pageSize, cursor, whitelabelOverrideKey, tagFilters, searchTerm) {
      return this.apiService.listAvailableApps(new ListAvailableAppsRequest({
        partnerId: partnerId,
        whitelabelOverrideKey: whitelabelOverrideKey,
        tagFilters: tagFilters,
        pagingOptions: new PagedRequestOptions({
          cursor,
          pageSize
        }),
        searchTerm: searchTerm
      }));
    }
    /*
        @params
          - partnerId: represents the partner Id to fetch the activatable apps for
          - marketId: a market based filter that will scope the response to contain activatable apps that can be activated in that market
        @returns: an observable of all activatable apps
        @throws: an HttpError if the client is unable to fetch the data
      */
    getAllActivatableApps(partnerId, marketId, whitelabelOverrideKey) {
      const response = this.apiService.listActivatableApps(new ListActivatableAppsRequest({
        partnerId: partnerId,
        marketId: marketId,
        pageSize: 0,
        cursor: '',
        whitelabelOverrideKey: whitelabelOverrideKey
      }));
      return response.pipe(map(resp => resp.activatableApps && resp.activatableApps.length ? convertActivatableApps(resp.activatableApps) : []));
    }
    /*
        @returns: an observable of all app distribution statuses
        @throws: an HttpError if the client is unable to fetch the data
      */
    getAllAppDistributionStatuses() {
      const response = this.apiService.listAppDistributionStatus(new ListAppDistributionStatusRequest({
        pageSize: 0,
        cursor: ''
      }));
      return response.pipe(map(resp => resp.appDistributionStatuses && resp.appDistributionStatuses.length ? resp.appDistributionStatuses : []));
    }
    getAllDistributedAppIds(partnerId, marketId, restrictToTypes) {
      const generatedTypes = restrictToTypes.map(sat => this.sharedAppTypeToProto(sat));
      const response = this.apiService.listDistributedAppIds(new ListDistributedAppIdsRequest({
        partnerId: partnerId,
        marketId: marketId,
        filters: new ListDistributedAppIdsRequestListDistributedAppIdsRequestFilters({
          appTypes: generatedTypes
        })
      }));
      return response.pipe(map(resp => resp.appIds && resp.appIds.length ? resp.appIds : []));
    }
    sharedAppTypeToProto(shared) {
      switch (shared) {
        case AppType.APP:
          return AppType$1.APP;
        case AppType.ADDON:
          return AppType$1.ADDON;
        case AppType.CUSTOM_PRODUCT:
          return AppType$1.CUSTOM_PRODUCT;
        default:
          return AppType$1.NOT_SPECIFIED;
      }
    }
    /*
        @returns: an observable of whether or not the app is distributed to that partner.
        @throws: an HttpError if the client is unable to fetch the data
    */
    isAppDistributedToPartner(appId, partnerId) {
      const response = this.apiService.isAppDistributedToPartner(new IsAppDistributedToPartnerRequest({
        appId: appId,
        partnerId: partnerId
      }));
      return response.pipe(map(resp => resp.isDistributed));
    }
    /*
      @returns: a list of observables like this
        {
          appId: string,
          isDistributed: boolean,
        }
      @throws: an HttpError if the client is unable to fetch the data
    */
    areAppsDistributedToPartner(partnerId, appIds) {
      const response = this.apiService.areAppsDistributedToPartner(new AreAppsDistributedToPartnerRequest({
        partnerId: partnerId,
        appIds: appIds
      }));
      return response.pipe(map(resp => resp.areAppsDistributed));
    }
  }
  MarketplaceAppService.ɵfac = function MarketplaceAppService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MarketplaceAppService)(i0.ɵɵinject(MarketplacePackagesApiService));
  };
  MarketplaceAppService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketplaceAppService,
    factory: MarketplaceAppService.ɵfac,
    providedIn: 'root'
  });
  return MarketplaceAppService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddonService = /*#__PURE__*/(() => {
  class AddonService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    /*
        @params:
          - partnerId: represents the partner to get the distributed/approved addonList map for.
          - appIds: is a list of appIds to filter the resulting map by.
          - whitelabelOverrideKey (optional): override the current whitelabel configuration
          If no appIds are provided, the resulting map will return all addons key'd by their parent.
        @returns: an observable of an es6 map with the app being the parent appId
        and the value being a list of addons that share that parent
        @throws: an HttpError if the client is unable to fetch the data
      */
    getMultiAddonsByApp(partnerId, appIds, whitelabelOverrideKey) {
      return this.fetchAddonToAppIdMap(partnerId, appIds, whitelabelOverrideKey).pipe(map(resp => resp ? this.convertInterfaceToMap(resp.addonMap) : null));
    }
    fetchAddonToAppIdMap(partnerId, appIds, whitelabelOverrideKey) {
      const response = this.apiService.getMultiAddonsByApp(new GetMultiAddonsByAppRequest({
        partnerId: partnerId,
        appIds: appIds,
        whitelabelOverrideKey: whitelabelOverrideKey
      }));
      return response;
    }
    convertInterfaceToMap(addonListContainerMap) {
      const addonMap = new Map();
      if (!addonListContainerMap) {
        return addonMap;
      }
      const keys = Object.keys(addonListContainerMap);
      keys.forEach(k => {
        const l = addonListContainerMap[k];
        if (l && l.addons && l.addons.length) {
          addonMap.set(k, l.addons);
        }
      });
      return addonMap;
    }
    /*
        @params:
          - partnerId: represents the partner to get the distributed/approved addons for.
          - appIds (optional): is a list of appIds to filter the list by.
          - whitelabelOverrideKey (optional): override the current whitelabel configuration
          If no appIds are provided, the resulting list will contain all addons.
        @returns: an observable of an array of addons
        @throws: an HttpError if the client is unable to fetch the data
      */
    getAllAddons(partnerId, appIds, whitelabelOverrideKey) {
      return this.fetchAddonToAppIdMap(partnerId, appIds || [], whitelabelOverrideKey).pipe(map(resp => resp && resp.addonMap ? this.flattenInterfaceToList(resp.addonMap) : []));
    }
    flattenInterfaceToList(addonListContainerMap) {
      let addonList = [];
      if (!addonListContainerMap) {
        return addonList;
      }
      const keys = Object.keys(addonListContainerMap);
      keys.forEach(k => {
        const l = addonListContainerMap[k];
        if (l && l.addons && l.addons.length) {
          addonList = addonList.concat(l.addons);
        }
      });
      return addonList;
    }
    /*
        @params:
          - partnerId: represents the partner to get the distributed/approved addon for.
          - addonId: is the id of the addon to fetch.
          - appId (optional): is the id of the parent of the desired addon to fetch. If the appId is avaliable, you should pass it in.
          - whitelabelOverrideKey (optional): override the current whitelabel configuration
          This function will be more performant
        @returns: an observable of an addon. If the addon does not exist, the observable will emit a value of null.
        @throws: an HttpError if the client is unable to fetch the data
      */
    getAddon(partnerId, addonId, appId, whitelabelOverrideKey) {
      let addonList$;
      if (appId) {
        addonList$ = this.fetchAddonToAppIdMap(partnerId, [appId], whitelabelOverrideKey).pipe(map(resp => {
          return resp && resp.addonMap && resp.addonMap[appId] && resp.addonMap[appId].addons ? resp.addonMap[appId].addons : [];
        }));
      } else {
        addonList$ = this.getAllAddons(partnerId, [], whitelabelOverrideKey);
      }
      return addonList$.pipe(map(l => this.getAddonFromList(addonId, l)));
    }
    getAddonFromList(addonId, addons) {
      const addon = addons.find(a => a.addonId === addonId);
      if (!addon) {
        throw new HttpErrorResponse({
          status: 404
        });
      }
      return addon;
    }
    /*
        @params:
          - partnerId: represents the partner to get the distributed/approved addon for.
          - addonIds: the ids of the addons to fetch.
          - appIds (optional): is the ids of the parents of the addons you wish to to fetch
          - whitelabelOverrideKey (optional): override the current whitelabel configuration
          This function will be more performant
        @returns: an observable of a map of an addonId to addon.
        @throws: an HttpError if the client is unable to fetch the data
      */
    getMultiAddon(partnerId, addonIds, appIds, whitelabelOverrideKey) {
      const addonList$ = this.fetchAddonToAppIdMap(partnerId, appIds || [], whitelabelOverrideKey).pipe(map(resp => resp && resp.addonMap ? this.flattenInterfaceToList(resp.addonMap) : []));
      return addonList$.pipe(map(al => {
        // Reducing to a map then filtering that map is a O(n) algorithm. Where as filtering a list on another list is O(n^2).
        const addonMap = al.reduce((am, a) => am.set(a.addonId, a), new Map());
        const filteredMap = new Map();
        addonIds.forEach(i => {
          const a = addonMap.get(i);
          if (a) {
            filteredMap.set(i, a);
          }
        });
        return filteredMap;
      }));
    }
  }
  AddonService.ɵfac = function AddonService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AddonService)(i0.ɵɵinject(MarketplacePackagesApiService));
  };
  AddonService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AddonService,
    factory: AddonService.ɵfac,
    providedIn: 'root'
  });
  return AddonService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StoreService = /*#__PURE__*/(() => {
  class StoreService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    buildStoreIdentifier(partnerId, marketId) {
      return new StoreIdentifier({
        partnerId: partnerId,
        marketId: marketId
      });
    }
    getStore(partnerId, marketId) {
      const req = new GetStoreRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId)
      });
      return this.apiService.getStore(req);
    }
    updateStore(partnerId, marketId, publicStoreSalesPersonId, useCustomCategories, fieldMask) {
      const req = new UpdateStoreRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        publicStoreSalesPersonId: publicStoreSalesPersonId,
        useCustomCategories: useCustomCategories,
        fieldMask: fieldMask
      });
      return this.apiService.updateStore(req).pipe(map(() => null));
    }
    setStoreCategoryOrder(partnerId, marketId, orderedCategoryIds) {
      const req = new SetStoreCategoryOrderRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        orderedCategoryIds: orderedCategoryIds
      });
      return this.apiService.setStoreCategoryOrder(req).pipe(map(() => null));
    }
    createStoreCategory(partnerId, marketId, name) {
      const req = new CreateStoreCategoryRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        name: name
      });
      return this.apiService.createStoreCategory(req).pipe(map(resp => resp.category));
    }
    deleteStoreCategory(partnerId, marketId, categoryId) {
      const req = new DeleteStoreCategoryRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        categoryId: categoryId
      });
      return this.apiService.deleteStoreCategory(req).pipe(map(() => null));
    }
    getCategoriesForStore(partnerId, marketId) {
      const req = new GetCategoriesForStoreRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId)
      });
      return this.apiService.getCategoriesForStore(req).pipe(map(resp => resp.categories));
    }
    updateStoreCategory(partnerId, marketId, categoryId, name, visibleInStore, fieldMask) {
      const req = new UpdateStoreCategoryRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        categoryId: categoryId,
        name: name,
        visibleInStore: visibleInStore,
        fieldMask: fieldMask
      });
      return this.apiService.updateStoreCategory(req).pipe(map(() => null));
    }
    listCategoriesForPackage(partnerId, marketId, packageId) {
      const req = new ListCategoriesForPackageRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        packageId: packageId
      });
      return this.apiService.listCategoriesForPackage(req).pipe(map(resp => resp.categories));
    }
    setPackagesInCategory(partnerId, marketId, packageIds, categoryId) {
      const req = new SetPackagesInCategoryRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        packageIds: packageIds,
        categoryId: categoryId
      });
      return this.apiService.setPackagesInCategory(req).pipe(map(() => null));
    }
    setCategoriesForPackage(partnerId, marketId, packageId, categoryIds) {
      const req = new SetCategoriesForPackageRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        packageId: packageId,
        categoryIds: categoryIds
      });
      return this.apiService.setCategoriesForPackage(req).pipe(map(() => null));
    }
    getStoreWithCategories(partnerId, marketId, bypassCache, getLegacyLmiCategories) {
      const r = new GetStoreWithCategoriesRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId),
        bypassCache: bypassCache,
        getLegacyLmiCategories: getLegacyLmiCategories
      });
      return this.apiService.getStoreWithCategories(r);
    }
    enableCustomCategoriesForStore(partnerId, marketId) {
      const r = new EnableCustomCategoriesForStoreRequest({
        storeId: this.buildStoreIdentifier(partnerId, marketId)
      });
      return this.apiService.enableCustomCategoriesForStore(r).pipe(map(resp => resp.categories));
    }
    getPublicStoreTheme(partnerID, marketID) {
      const req = new GetPublicStoreThemeRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: marketID
        })
      });
      return this.apiService.getPublicStoreTheme(req);
    }
    updatePublicStoreTheme(partnerID, marketID, publicStoreTheme) {
      const req = new UpdatePublicStoreThemeRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: marketID
        }),
        publicStoreTheme: publicStoreTheme
      });
      return this.apiService.updatePublicStoreTheme(req);
    }
    removeFromStore(partnerID, marketID, productId) {
      const req = new RemoveFromStoreRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: marketID
        }),
        productReferenceId: productId
      });
      return this.apiService.removeFromStore(req);
    }
    addToStore(partnerID, marketID, appId) {
      const req = new AddToStoreRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: marketID
        }),
        appId: appId
      });
      return this.apiService.addToStore(req);
    }
    addToStores(partnerId, storeIds, itemId) {
      const req = new AddToStoresRequest({
        partnerId: partnerId,
        storeIds: storeIds,
        itemId: itemId
      });
      return this.apiService.addToStores(req);
    }
    checkProductVisibility(partnerID, marketID, appId) {
      const req = new CheckProductVisibilityRequest({
        partnerId: partnerID,
        marketIds: marketID,
        productReferenceId: appId
      });
      return this.apiService.checkProductVisibility(req).pipe(map(resp => resp.productVisibilty));
    }
    listProductsInStore(partnerID, storeID, cursor, pageSize, filters) {
      const req = new ListProductsInStoreRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: storeID
        }),
        cursor: cursor,
        pageSize: pageSize,
        filters: filters
      });
      return this.apiService.listProductsInStore(req);
    }
    listVisibleAddonsForProduct(partnerID, storeID, cursor, pageSize, appID) {
      const req = new ListVisibleAddonsForProductRequest({
        storeId: new StoreIdentifier({
          partnerId: partnerID,
          marketId: storeID
        }),
        appId: appID,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.apiService.listVisibleAddonsForProduct(req);
    }
    listStorePricePreviews(partnerID, productID) {
      const req = new ListStorePricePreviewsRequest({
        partnerId: partnerID,
        productId: productID
      });
      return this.apiService.listStorePricePreviews(req).pipe(map(resp => resp.previews));
    }
    getMultiStorePricePreviews(partnerID, productIDs) {
      const req = new GetMultiStorePricePreviewsRequest({
        partnerId: partnerID,
        productIds: productIDs
      });
      return this.apiService.getMultiStorePricePreviews(req).pipe(map(resp => resp.productPreviews));
    }
    listStoreProductVisibilitySummaries(partnerId) {
      const req = new ListStoreProductVisibilitySummariesRequest({
        partnerId
      });
      return this.apiService.listStoreProductVisibilitySummaries(req).pipe(map(resp => resp.summaries), map(summaries => {
        const m = new Map();
        for (const k in summaries) {
          if (summaries.hasOwnProperty(k)) {
            m.set(k, summaries[k]);
          }
        }
        return m;
      }));
    }
    hasPartnerSetStoreOrder(partnerId) {
      const req = new HasPartnerSetStoreOrderRequest({
        partnerId
      });
      return this.apiService.hasPartnerSetStoreOrder(req).pipe(map(resp => resp.result));
    }
  }
  StoreService.ɵfac = function StoreService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StoreService)(i0.ɵɵinject(MarketplaceStoreApiService));
  };
  StoreService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: StoreService,
    factory: StoreService.ɵfac,
    providedIn: "root"
  });
  return StoreService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var LMICategories = /*#__PURE__*/function (LMICategories) {
  LMICategories[LMICategories["NOT_SET"] = 0] = "NOT_SET";
  LMICategories[LMICategories["WEBSITE"] = 1] = "WEBSITE";
  LMICategories[LMICategories["CONTENT_AND_EXPERIENCE"] = 2] = "CONTENT_AND_EXPERIENCE";
  LMICategories[LMICategories["LISTINGS"] = 3] = "LISTINGS";
  LMICategories[LMICategories["REPUTATION"] = 4] = "REPUTATION";
  LMICategories[LMICategories["SEO"] = 5] = "SEO";
  LMICategories[LMICategories["SOCIAL"] = 6] = "SOCIAL";
  LMICategories[LMICategories["ADVERTISING"] = 7] = "ADVERTISING";
  return LMICategories;
}(LMICategories || {});
// converts lmi category ids to enum values
const LMI_TO_ENUM_MAP = {
  listings: LMICategories.LISTINGS,
  social: LMICategories.SOCIAL,
  reputation: LMICategories.REPUTATION,
  seo: LMICategories.SEO,
  website: LMICategories.WEBSITE,
  advertising: LMICategories.ADVERTISING,
  content_and_experience: LMICategories.CONTENT_AND_EXPERIENCE
};
// converts lmi enum values to category objects based on the index of the array.
// Note that this enum is shared by conversion functionality for mp-apps and packages
const ENUM_TO_LMI_ARRAY = [
// first value represents the unset category, because of how proto enums work.
null, {
  name: "Website",
  categoryId: "website"
}, {
  name: "Content & Experience",
  categoryId: "content_and_experience"
}, {
  name: "Listings",
  categoryId: "listings"
}, {
  name: "Reputation",
  categoryId: "reputation"
}, {
  name: "SEO",
  categoryId: "seo"
}, {
  name: "Social",
  categoryId: "social"
}, {
  name: "Advertising",
  categoryId: "advertising"
}];
// list of all lmi categories
const LMI_CATEGORIES = [{
  name: "Listings",
  categoryId: "listings"
}, {
  name: "Social",
  categoryId: "social"
}, {
  name: "Reputation",
  categoryId: "reputation"
}, {
  name: "SEO",
  categoryId: "seo"
}, {
  name: "Website",
  categoryId: "website"
}, {
  name: "Advertising",
  categoryId: "advertising"
}, {
  name: "Content & Experience",
  categoryId: "content_and_experience"
}];
// converts category id to lmi category
const LMI_CATEGORY_MAP = LMI_CATEGORIES.reduce((previous, current) => {
  previous[current.categoryId] = current;
  return previous;
}, {});
const sdkLmiEnumToStringMap = new Map([[LmiCategories.ADVERTISING, "Advertising"], [LmiCategories.CONTENT_AND_EXPERIENCE, "Content and Experience"], [LmiCategories.LISTINGS, "Listings"], [LmiCategories.REPUTATION, "Reputation"], [LmiCategories.SEO, "SEO"], [LmiCategories.SOCIAL, "Social"], [LmiCategories.WEBSITE, "Website"]]);
/**
 * converts lmi enum values to lmi category objects
 */
function convertLmiEnumToCategoryObject(categoryId) {
  return ENUM_TO_LMI_ARRAY[categoryId];
}
/**
 * converts lmi enum values to the display string equivalent
 */
function convertSDKLmiEnumToDisplayString(cat) {
  return sdkLmiEnumToStringMap.get(cat);
}
/**
 * converts multiple sdk lmi enum values to display strings
 */
function convertSDKLmiEnumsToDisplayStrings(cats) {
  return (cats || []).map(cat => convertSDKLmiEnumToDisplayString(cat));
}
function getCurrencyCode(currency, fallback) {
  switch (currency) {
    case CurrenciesCurrency.USD:
      return 'USD';
    case CurrenciesCurrency.AUD:
      return 'AUD';
    case CurrenciesCurrency.BRL:
      return 'BRL';
    case CurrenciesCurrency.CAD:
      return 'CAD';
    case CurrenciesCurrency.CHF:
      return 'CHF';
    case CurrenciesCurrency.CNY:
      return 'CNY';
    case CurrenciesCurrency.CZK:
      return 'CZK';
    case CurrenciesCurrency.EUR:
      return 'EUR';
    case CurrenciesCurrency.GBP:
      return 'GBP';
    case CurrenciesCurrency.HKD:
      return 'HKD';
    case CurrenciesCurrency.INR:
      return 'INR';
    case CurrenciesCurrency.JPY:
      return 'JPY';
    case CurrenciesCurrency.KHR:
      return 'KHR';
    case CurrenciesCurrency.KRW:
      return 'KRW';
    case CurrenciesCurrency.MXN:
      return 'MXN';
    case CurrenciesCurrency.NOK:
      return 'NOK';
    case CurrenciesCurrency.NZD:
      return 'NZD';
    case CurrenciesCurrency.RUB:
      return 'RUB';
    case CurrenciesCurrency.SEK:
      return 'SEK';
    case CurrenciesCurrency.SGD:
      return 'SGD';
    case CurrenciesCurrency.TRY:
      return 'TRY';
    case CurrenciesCurrency.ZAR:
      return 'ZAR';
    case CurrenciesCurrency.DZD:
      return 'DZD';
    case CurrenciesCurrency.AWG:
      return 'AWG';
    case CurrenciesCurrency.FJD:
      return 'FJD';
    case CurrenciesCurrency.KYD:
      return 'KYD';
    default:
      if (fallback !== undefined) {
        return fallback;
      }
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unexpected currency enumeration: ${currency}`);
  }
}
let AppPartnerSettingsService = /*#__PURE__*/(() => {
  class AppPartnerSettingsService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    _buildGetRetailPrice(appId, businessIdentifier, editionId, dontUseMsrp = false) {
      if (!appId || !businessIdentifier) {
        return null;
      }
      const r = new GetRetailPriceRequest();
      r.appId = appId;
      r.editionId = editionId;
      r.dontUseMsrp = dontUseMsrp;
      if (businessIdentifier instanceof PartnerMarketContainer) {
        if (businessIdentifier.partnerId) {
          r.partnerMarket = new PartnerMarketContainer();
          r.partnerMarket.partnerId = businessIdentifier.partnerId;
          r.partnerMarket.marketId = businessIdentifier.marketId;
          return r;
        }
        return null;
      } else {
        r.businessId = businessIdentifier;
        return r;
      }
      return null;
    }
    _buildGetMultiRetailPrice(businessIdentifier, productIds) {
      const r = new GetMultiRetailPriceRequest({
        productIds
      });
      if (businessIdentifier instanceof PartnerMarketContainer) {
        r.partnerMarket = businessIdentifier;
      } else {
        r.businessId = businessIdentifier;
      }
      return r;
    }
    /*
      @params:
        - appId: represents id of the app to get the retail price for.
        - businessIdentifier: is either a string representing the business id, or object containing the partner/market ids
        that a busines maps too. note that if you don't pass either the businessId container or the partner/market ids container
        you will receive an error event of type HttpErrorResponse. This response will contain a 404 code.
        - editionId (optional): is the edition id of the app to fetch the retail price for.
        - dontUseMsrp (optional): option to bypass msrp from apps. If set to true, msrp from apps will not be used if retail
        price information is not available. Default is false.
      @returns: an observable of the RetailPrice definition, or an observable containing and HttpErrorResponse
    */
    getRetailPrice(appId, businessIdentifier, editionId, dontUseMsrp) {
      const r = this._buildGetRetailPrice(appId, businessIdentifier, editionId, dontUseMsrp);
      if (!r) {
        const e = new HttpErrorResponse({
          status: 404,
          statusText: "You must either pass in a partner Id with an optional market Id in an object or a business Id in an object"
        });
        return throwError(e);
      }
      return this.apiService.getRetailPrice(r).pipe(map(resp => (resp || {
        retailPrice: null
      }).retailPrice));
    }
    /**
     * @param businessIdentifier - either a string representing the business id, or object containing the partner/market ids that the business
     *    belongs to
     * @param productIds - the list of app/edition ID combinations to get the retail price for
     */
    getMultiRetailPrice(businessIdentifier, productIds) {
      const r = this._buildGetMultiRetailPrice(businessIdentifier, productIds);
      return this.apiService.getMultiRetailPrice(r).pipe(map(resp => resp.retailPrices));
    }
    /*
      @params:
        - appId: represents id of the app to set the retail price for.
        - partnerId: the id of the partner to associated this retail price.
        - retailPrice: the retail price to be set for the app.
        - editionId (optional): is the edition id of the app to set the retail price for.
        - marketId (optional): is a sub group nested under the partner corresponding to partnerId.
         @returns: an observable of the RetailPrice definition.
    */
    createOrUpdateRetailPrice(appId, partnerId, retailPrice, editionId, marketId) {
      const req = new CreateOrUpdateRetailPriceRequest();
      req.appId = appId;
      req.editionId = editionId;
      req.partnerId = partnerId;
      req.marketId = marketId;
      req.retailPrice = retailPrice;
      return this.apiService.createOrUpdateRetailPrice(req).pipe(map(resp => (resp || {
        retailPrice: null
      }).retailPrice));
    }
    /*
        @params:
          - appId: represents id of the app to delete the retail price information.
          - partnerId: the id of the partner to which the retail price is associated.
          - editionId (optional): is the edition id of the app to delete the retail price information.
          - marketId (optional): is a sub group nested under the partner corresponding to partnerId.
        @returns: an observable of HttpErrorResponse
      */
    deleteRetailPrice(appId, partnerId, editionId, marketId) {
      const req = new DeleteRetailPriceRequest();
      req.appId = appId;
      req.editionId = editionId;
      req.partnerId = partnerId;
      req.marketId = marketId;
      return this.apiService.deleteRetailPrice(req);
    }
    convertRetailPricesForMarket(partnerId, marketId, currency, conversionRate) {
      const req = new ConvertRetailPricesForMarketRequest();
      req.partnerMarket = new PartnerMarketContainer();
      req.partnerMarket.marketId = marketId;
      req.partnerMarket.partnerId = partnerId;
      req.currency = currency;
      req.conversionRate = conversionRate;
      return this.apiService.convertRetailPricesForMarket(req);
    }
  }
  AppPartnerSettingsService.ɵfac = function AppPartnerSettingsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AppPartnerSettingsService)(i0.ɵɵinject(AppPartnerSettingsApiService));
  };
  AppPartnerSettingsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppPartnerSettingsService,
    factory: AppPartnerSettingsService.ɵfac,
    providedIn: "root"
  });
  return AppPartnerSettingsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShoppingCartService = /*#__PURE__*/(() => {
  class ShoppingCartService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    getShoppingCart(businessId) {
      const req = new GetShoppingCartRequest({
        businessId: businessId
      });
      return this.apiService.getShoppingCart(req).pipe(map(resp => resp.cart));
    }
    addToShoppingCart(businessId, itemId, itemType, editionId) {
      const req = new AddToShoppingCartRequest({
        businessId,
        itemId,
        editionId,
        itemType
      });
      return this.apiService.addToShoppingCart(req).pipe(map(resp => resp.cart));
    }
    addMultiToShoppingCart(businessId, items) {
      const req = new AddMultiToShoppingCartRequest({
        businessId,
        items
      });
      return this.apiService.addMultiToShoppingCart(req).pipe(map(resp => resp.cart));
    }
    updateItemQuantity(businessID, itemID, quantity) {
      const req = new UpdateItemQuantityRequest({
        businessId: businessID,
        itemId: itemID,
        quantity: quantity
      });
      return this.apiService.updateItemQuantity(req).pipe(map(resp => resp.cart));
    }
    removeFromShoppingCart(businessId, itemId) {
      const req = new RemoveFromShoppingCartRequest({
        businessId: businessId,
        itemId: itemId
      });
      return this.apiService.removeFromShoppingCart(req).pipe(map(resp => resp.cart));
    }
    removeMultiFromShoppingCart(businessId, itemIds) {
      const req = new RemoveMultiFromShoppingCartRequest({
        businessId,
        itemIds
      });
      return this.apiService.removeMultiFromShoppingCart(req).pipe(map(resp => resp.cart));
    }
    clearShoppingCart(businessId) {
      const req = new ClearShoppingCartRequest({
        businessId: businessId
      });
      return this.apiService.clearShoppingCart(req).pipe(map(resp => resp.cart));
    }
  }
  ShoppingCartService.ɵfac = function ShoppingCartService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ShoppingCartService)(i0.ɵɵinject(ShoppingCartApiService));
  };
  ShoppingCartService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ShoppingCartService,
    factory: ShoppingCartService.ɵfac,
    providedIn: 'root'
  });
  return ShoppingCartService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuyItNowService = /*#__PURE__*/(() => {
  class BuyItNowService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    generateBuyItNowLink(accountGroupID, userID, packageID) {
      const req = new GenerateBuyItNowLinkRequest({
        accountGroupId: accountGroupID,
        userId: userID,
        packageId: packageID
      });
      return this.apiService.generateBuyItNowLink(req);
    }
    getBuyItNowLinkByLinkID(linkID) {
      const req = new GetBuyItNowLinkByLinkIDRequest({
        linkId: linkID
      });
      return this.apiService.getBuyItNowLinkByLinkId(req).pipe(map(resp => resp.link));
    }
  }
  BuyItNowService.ɵfac = function BuyItNowService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BuyItNowService)(i0.ɵɵinject(BuyItNowApiService));
  };
  BuyItNowService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BuyItNowService,
    factory: BuyItNowService.ɵfac,
    providedIn: 'root'
  });
  return BuyItNowService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, ActivatableApp, AddMultiToShoppingCartRequest, AddMultiToShoppingCartRequestItem, AddProductToStoreRequest, AddToShoppingCartRequest, AddToStoreRequest, AddToStoresRequest, Addon, AddonKey, AddonOptions, AddonService, AppData, ListAppDistributionStatusResponseAppDistributionStatus as AppDistributionStatus, AppEnablementStatusesAppEnablementStatus as AppEnablementStatus, AppEnablementStatuses, AppEnablementStatusesAppEnablementStatus, AppPartnerSettingsApiService, AppPartnerSettingsService, AppSummary, AppType, AreAppsDistributedToPartnerRequest, AreAppsDistributedToPartnerResponse, AreAppsDistributedToPartnerResponseAppDistributedContainer, BillingWholesalePricing, BulkCopyPackageRequest, BulkCopyPackageRequestPackageSource, BulkCopyPackageResponse, BuyItNowApiService, BuyItNowLink, BuyItNowService, LmiCategories as Categories, Category, CheckProductVisibilityRequest, CheckProductVisibilityResponse, CheckProductVisibilityResponseProductVisibiltyEntry, ClearShoppingCartRequest, Commitment, ContactFormAction, ConvertRetailPricesForMarketRequest, CopyPackageRequest, CopyPackageResponse, Cost, CreateOrUpdateRetailPriceRequest, CreatePackageRequest, CreatePackageResponse, CreateStoreCategoryRequest, CreateStoreCategoryResponse, Currencies, CurrenciesCurrency, CurrenciesCurrency as Currency, DefaultAction, DeletePackageRequest, DeleteRetailPriceRequest, DeleteStoreCategoryRequest, DisableAppForPartnerRequest, DiscoverProductSortOrderType, DiscoverableAppParent, DiscoverableAppSummary, ENUM_TO_LMI_ARRAY, EnableAppForPartnerRequest, EnableCustomCategoriesForStoreRequest, EnableCustomCategoriesForStoreResponse, ExternalUrlAction, FieldMask, Frequencies, FrequenciesFrequency, FrequenciesFrequency as Frequency, FrequentlyAskedQuestions, GenerateBuyItNowLinkRequest, GenerateBuyItNowLinkResponse, GetBuyItNowLinkByLinkIDRequest, GetBuyItNowLinkByLinkIDResponse, GetCategoriesForStoreRequest, GetCategoriesForStoreResponse, GetMultiAddonsByAppRequest, GetMultiAddonsByAppResponse, GetMultiAddonsByAppResponseAddonListContainer, GetMultiAddonsByAppResponseAddonMapEntry, GetMultiAddonsRequest, GetMultiAddonsResponse, GetMultiIsAppEnabledRequest, GetMultiIsAppEnabledResponse, GetMultiIsAppEnabledResponseAppEnablement, GetMultiPackageRequest, GetMultiPackageResponse, GetMultiPackageResponsePackageContainer, GetMultiPartnerAppEnablementStatusRequest, GetMultiPartnerAppEnablementStatusResponse, GetMultiProductsRequest, GetMultiProductsResponse, GetMultiProductsResponseProductContainer, GetMultiRetailPriceRequest, GetMultiRetailPriceResponse, GetMultiRetailPriceResponseRetailPriceResponse, GetMultiStorePricePreviewsRequest, GetMultiStorePricePreviewsResponse, GetPublicStoreThemeRequest, GetPublicStoreThemeResponse, GetRetailPriceRequest, GetRetailPriceResponse, GetShoppingCartRequest, GetStoreRequest, GetStoreResponse, GetStoreWithCategoriesRequest, GetStoreWithCategoriesResponse, HasPartnerSetStoreOrderRequest, HasPartnerSetStoreOrderResponse, HideArchivedPackageRequest, IncludedCommonFormFields, IsAppDistributedToPartnerRequest, IsAppDistributedToPartnerResponse, IsShoppingCartEnabledRequest, IsShoppingCartEnabledResponse, KindValues, LMICategories, LMI_CATEGORIES, LMI_CATEGORY_MAP, LMI_TO_ENUM_MAP, LineItem, LineItems, ListActivatableAppsRequest, ListActivatableAppsResponse, ListAddonsRequest, ListAddonsResponse, ListAppDistributionStatusRequest, ListAppDistributionStatusResponse, ListAppDistributionStatusResponseAppDistributionStatus, ListAvailableAppsRequest, ListAvailableAppsResponse, ListCategoriesForPackageRequest, ListCategoriesForPackageResponse, ListDiscoverableAppSuggestionsRequest, ListDiscoverableAppSuggestionsResponse, ListDiscoverableAppSuggestionsResponseSuggestion, ListDiscoverableAppsRequest, ListDiscoverableAppsResponse, ListDistributedAppIdsRequest, ListDistributedAppIdsRequestListDistributedAppIdsRequestFilters, ListDistributedAppIdsResponse, ListPackageIDsForProductRequest, ListPackageIDsForProductResponse, ListPackagesRequest, ListPackagesResponse, ListPartnerAppEnablementStatusRequest, ListPartnerAppEnablementStatusResponse, ListProductFilter, ListProductsInStoreFilters, ListProductsInStoreRequest, ListProductsInStoreResponse, ListProductsRequest, ListProductsResponse, ListStorePricePreviewsRequest, ListStorePricePreviewsResponse, ListStoreProductVisibilitySummariesRequest, ListStoreProductVisibilitySummariesResponse, ListStoreProductVisibilitySummariesResponseStoreProductVisibilitySummary, ListStoreProductVisibilitySummariesResponseSummariesEntry, ListVisibleAddonsForProductRequest, ListVisibleAddonsForProductResponse, Lmi, LmiCategories, MarketAction, MarketingInformation, MarketplaceAppService, MarketplacePackagesApiService, MarketplaceStoreApiService, OrderForm, OrderFormAction, OrderFormField, Package, PackageIdContainer, PackageScope, PackageService, PagedRequestOptions, PagedResponseMetadata, PartnerAppEnablementStatusService, PartnerAppRequest, PartnerAppResponse, PartnerMarketContainer, PermissionLists, Price, Pricing, PricingDisplayOption, Product, ProductIdentifier, ProductPricePreviews, ProductPricingRule, ProductPricingType, ProductService, ProductWholesalePrice, PublicStoreTheme, RemoveFromShoppingCartRequest, RemoveFromStoreRequest, RemoveMultiFromShoppingCartRequest, Restrictions, RetailPrice, ServiceModel, ServiceModelType, SetCategoriesForPackageRequest, SetPackagesInCategoryRequest, SetStoreCategoryOrderRequest, ShoppingCart, ShoppingCartApiService, ShoppingCartItemType, ShoppingCartResponse, ShoppingCartService, ShoppingCartShoppingCartItem, State, StateFilterOptions, StatusesStatus as Status, Statuses, StatusesStatus, StoreIdentifier, StorePricePreview, StorePricePreviews, StoreProduct, StoreService, Tag, ServiceModelType as Type, UpdateEvent, UpdateItemQuantityRequest, UpdatePackageOperation, UpdatePackageRequest, UpdatePackageResponse, UpdatePublicStoreThemeRequest, UpdateStoreCategoryRequest, UpdateStoreRequest, VendorRetailPrice, WholesalePrice, convertActivatableApps, convertLmiEnumToCategoryObject, convertSDKLmiEnumToDisplayString, convertSDKLmiEnumsToDisplayStrings, getCurrencyCode, sdkLmiEnumToStringMap };
